



// import { useEffect, useRef, useState, forwardRef } from 'react';
// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { fetchCertificates, fetchReviews, REST_BASE, API_KEY } from './data';

// gsap.registerPlugin(ScrollTrigger);

// const pad = n => String(n).padStart(2, '0');

// // ─── Constants ────────────────────────────────────────────────────
// const HEADER_H     = 120;
// const TICKER_H     = 36;
// const IMAGE_ZONE_H = 260;

// const MOBILE_TEXT_H = `calc(100vh - ${HEADER_H}px - ${IMAGE_ZONE_H}px - ${TICKER_H}px)`;
// const OUTRO_BUDGET  = 3.5;

// // Circle reveal completes at this fraction before image/cards start
// const REVEAL_THRESHOLD = 0.35;

// // Within postReveal progress: image occupies first IMAGE_PHASE, then cards
// const IMAGE_PHASE = 0.45;

// // ─── Firestore REST helpers ───────────────────────────────────────
// function fromValue(v) {
//   if (!v) return null;
//   if ('stringValue'  in v) return v.stringValue;
//   if ('integerValue' in v) return Number(v.integerValue);
//   if ('doubleValue'  in v) return Number(v.doubleValue);
//   if ('booleanValue' in v) return v.booleanValue;
//   if ('nullValue'    in v) return null;
//   if ('arrayValue'   in v) return (v.arrayValue.values || []).map(fromValue);
//   if ('mapValue'     in v) {
//     const o = {};
//     for (const [k, val] of Object.entries(v.mapValue.fields || {})) o[k] = fromValue(val);
//     return o;
//   }
//   return null;
// }
// function fromFields(fields) {
//   const o = {};
//   for (const [k, v] of Object.entries(fields)) o[k] = fromValue(v);
//   return o;
// }

// // ─── Level colour map ─────────────────────────────────────────────
// const LEVEL_MAP = {
//   Expert:       { bg: 'rgba(83,74,183,0.15)',  border: '#534AB7', text: '#AFA9EC' },
//   Professional: { bg: 'rgba(15,110,86,0.15)',  border: '#0F6E56', text: '#5DCAA5' },
//   Associate:    { bg: 'rgba(133,79,11,0.15)',  border: '#854F0B', text: '#EF9F27' },
// };

// // ─── Preload cert images ──────────────────────────────────────────
// function preloadCertImages(certs) {
//   certs.forEach(cert => {
//     if (!cert.src) return;
//     const img = new Image();
//     img.fetchPriority = 'auto';
//     img.src = cert.src;
//   });
// }

// // ─── Fallback reviews ────────────────────────────────────────────
// const FALLBACK_REVIEWS = [
//   {
//     id: '01',
//     name: 'Arju',
//     role: 'Founder, Orbit Labs',
//     text: 'Naveen has a rare instinct for turning vague briefs into something that feels inevitable. Every animation, every hover state — nothing felt like a default.',
//     tag: 'UI/UX',
//     year: '2024',
//   },
//   {
//     id: '02',
//     name: 'Sarah Lindström',
//     role: 'Creative Director, Helix Studio',
//     text: 'The portfolio site he built us stopped people mid-scroll. We got three new client inquiries the week it launched, all citing the site directly.',
//     tag: 'Frontend Dev',
//     year: '2024',
//   },
//   {
//     id: '03',
//     name: 'Kabir Nair',
//     role: 'CTO, Stackfield',
//     text: 'Technically sharp and visually fluent — an unusual combination. He rebuilt our admin panel from the ground up and the performance gains were immediate.',
//     tag: 'Full Stack',
//     year: '2023',
//   },
//   {
//     id: '04',
//     name: 'Priya Rajan',
//     role: 'Head of Product, Nomad OS',
//     text: 'What stood out was the attention to micro-interactions. Every transition felt earned. He pushed back on two of my ideas and was right both times.',
//     tag: 'Product Design',
//     year: '2023',
//   },
//   {
//     id: '05',
//     name: 'Tom Breckenridge',
//     role: 'Lead Engineer, Vanta Systems',
//     text: 'Clean, maintainable React. The GSAP work was surgical — no bloat, no jank. Rare to find someone who cares about the code as much as the output.',
//     tag: 'React / GSAP',
//     year: '2023',
//   },
// ];

// const TILTS   = [-4, 2.5, -1.5, 3, -2, -3.5, 1.8, -2.2, 3.5, -1];
// const OFFSETS = [0, -6, 4, -3, 5, -4, 3, -5, 2, -2];

// // ─── Easing ───────────────────────────────────────────────────────
// function easeOutBack(t) {
//   const c1 = 1.70158;
//   const c3 = c1 + 1;
//   return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2);
// }

// // ─── ReviewCard ───────────────────────────────────────────────────
// const ReviewCard = forwardRef(function ReviewCard({ review, isMobile }, ref) {
//   const cardW = isMobile ? 'min(82vw, 340px)' : '40vw';

//   return (
//     <div
//       ref={ref}
//       style={{
//         position:     'absolute',
//         width:        cardW,
//         background:   'var(--black)',
//         border:       '1px solid var(--border)',
//         borderRadius: '6px',
//         padding:      isMobile ? '1.4rem 1.2rem' : '2.2rem 2rem',
//         boxSizing:    'border-box',
//         willChange:   'transform',
//       }}
//     >
//       {/* Tag */}
//       <div style={{
//         display:        'flex',
//         justifyContent: 'space-between',
//         alignItems:     'center',
//         marginBottom:   isMobile ? '1rem' : '1.6rem',
//       }}>
//         <span style={{
//           fontFamily:    'Space Mono, monospace',
//           fontSize:      '0.6rem',
//           color:         'var(--acid)',
//           letterSpacing: '0.18em',
//           textTransform: 'uppercase',
//           border:        '1px solid var(--border)',
//           borderRadius:  '2px',
//           padding:       '0.2rem 0.5rem',
//         }}>
//           {review.tag}
//         </span>
//       </div>

//       {/* Quote mark */}
//       <div style={{
//         fontFamily:   'Syne, sans-serif',
//         fontSize:     isMobile ? '2.4rem' : '3.5rem',
//         lineHeight:   0.7,
//         color:        'var(--white)',
//         marginBottom: isMobile ? '0.6rem' : '0.8rem',
//         userSelect:   'none',
//       }}>
//         "
//       </div>

//       {/* Review text */}
//       <p style={{
//         fontFamily:   'Space Mono, monospace',
//         fontSize:     isMobile
//           ? 'clamp(0.5rem, 2.2vw, 0.65rem)'
//           : 'clamp(0.6rem, 1vw, 0.78rem)',
//         lineHeight:   1.8,
//         color:        'var(--white)',
//         opacity:      0.75,
//         margin:       0,
//         marginBottom: isMobile ? '1.2rem' : '2rem',
//       }}>
//         {review.text}
//       </p>

//       {/* Divider */}
//       <div style={{
//         height:       '1px',
//         background:   'var(--border)',
//         marginBottom: isMobile ? '0.8rem' : '1.2rem',
//       }} />

//       {/* Reviewer info */}
//       <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
//         <div>
//           <div style={{
//             fontFamily:    'Syne, sans-serif',
//             fontSize:      isMobile ? '0.6rem' : '0.75rem',
//             fontWeight:    700,
//             color:         'var(--white)',
//             letterSpacing: '-0.02em',
//             marginBottom:  '0.15rem',
//           }}>
//             {review.name}
//           </div>
//           <div style={{
//             fontFamily:    'Space Mono, monospace',
//             fontSize:      '0.6rem',
//             color:         'var(--dummy)',
//             letterSpacing: '0.06em',
//           }}>
//             {review.role}
//           </div>
//         </div>
//         <span style={{
//           fontFamily:    'Space Mono, monospace',
//           fontSize:      '0.6rem',
//           color:         'var(--dummy)',
//           letterSpacing: '0.1em',
//         }}>
//           {review.year}
//         </span>
//       </div>
//     </div>
//   );
// });

// // ─── OutroReviews ─────────────────────────────────────────────────
// // imageProgress  0→1 — drives the maskImage sliding in from right
// // cardProgress   0→1 — drives review cards flying in from left
// // maskImage      — the base image URL from Firestore settings/certificates
// function OutroReviews({ imageProgress, cardProgress, isMobile, reviews: reviewsProp, maskImage }) {
//   const cardRefs   = useRef([]);
//   const imgWrapRef = useRef(null);
//   const progressRef = useRef({ img: 0, card: 0 });
//   const rafRef     = useRef(null);

//   const ITEMS = (reviewsProp && reviewsProp.length > 0) ? reviewsProp : FALLBACK_REVIEWS;
//   const total = ITEMS.length;

//   // Keep live ref for rAF
//   useEffect(() => {
//     progressRef.current = { img: imageProgress, card: cardProgress };
//   }, [imageProgress, cardProgress]);

//   // One-time: set initial off-screen positions
//   useEffect(() => {
//     // Cards start off-screen LEFT
//     cardRefs.current.forEach((card, i) => {
//       if (!card) return;
//       gsap.set(card, {
//         x:        '-120vw',
//         y:        OFFSETS[i] ?? 0,
//         rotation: TILTS[i]  ?? 0,
//         zIndex:   i,
//         opacity:  1,
//       });
//     });
//     // Image starts off-screen RIGHT
//     if (imgWrapRef.current) {
//       gsap.set(imgWrapRef.current, { x: '110vw' });
//     }
//   }, [ITEMS.length]);

//   // rAF loop driving both image and cards
//   useEffect(() => {
//     function tick() {
//       const { img: imgP, card: cardP } = progressRef.current;

//       // Image slides in from right
//       if (imgWrapRef.current) {
//         const eImg = easeOutBack(Math.min(1, imgP));
//         gsap.set(imgWrapRef.current, {
//           x: window.innerWidth * 1.1 * (1 - eImg),
//         });
//       }

//       // Cards fly in from left, staggered
//       cardRefs.current.forEach((card, i) => {
//         if (!card) return;
//         const landStart = i / total;
//         const landP     = Math.max(0, Math.min(1, (cardP - landStart) / (1 / total)));
//         const eL        = easeOutBack(landP);
//         gsap.set(card, {
//           x:        -window.innerWidth * 1.2 * (1 - eL),
//           y:        OFFSETS[i] ?? 0,
//           rotation: TILTS[i]  ?? 0,
//           zIndex:   i,
//         });
//       });

//       rafRef.current = requestAnimationFrame(tick);
//     }
//     rafRef.current = requestAnimationFrame(tick);
//     return () => cancelAnimationFrame(rafRef.current);
//   }, [total]);

//   return (
//     <div style={{
//       width:         '100%',
//       height:        '100%',
//       background:    'var(--black)',
//       display:       'flex',
//       flexDirection: 'column',
//       overflow:      'hidden',
//       position:      'relative',
      
//     }}
//     data-cursor-text="Scroll Down"
//     >

//       {/* ── Header ──────────────────────────────────────────────── */}
//       <div style={{
//         padding:    '2rem 5vw 1.5rem',
//         flexShrink: 0,
//         position:   'relative',
//         zIndex:     20,
//       }}>
//         <div style={{
//           display:        'flex',
//           alignItems:     isMobile ? 'flex-start' : 'baseline',
//           flexDirection:  isMobile ? 'row' : 'row',
//           justifyContent: 'center',
//           gap:            isMobile ? '0.4rem' : '1rem',
//           marginBottom:   '0.75rem',
//         }}>
//           <div style={{
//             fontFamily:    'Syne, sans-serif',
//             fontSize:      isMobile
//               ? 'clamp(1rem, 8vw, 1.2rem)'
//               : 'clamp(1rem, 4vw, 1.2rem)',
//             fontWeight:    800,
//             letterSpacing: '-0.05em',
//             lineHeight:    0.9,
//             textAlign:     'center',
//             color:         'var(--white)',
//           }}>
//             Kind <span style={{ color: 'var(--acid)' }}>Words</span>
//           </div>
//         </div>
//         <p style={{
//           textAlign:  'center',
//           color:      'var(--muted)',
//           maxWidth:   '700px',
//           margin:     '0 auto',
//           lineHeight: '1.6',
//         }}>
//           Feedback from founders, clients, and teams.
//         </p>
//       </div>

//       {/* ── Main area: image right + cards left ─────────────────── */}
//       <div style={{
//         flex:     1,
//         position: 'relative',
//         overflow: 'hidden',
//       }}>

//         {/* ── maskImage — slides in from right (desktop only) ───── */}
//         {!isMobile && maskImage && (
//           <div
//             ref={imgWrapRef}
//             style={{
//               position:  'absolute',
//               right:      0,
//               top:        0,
//               bottom:     0,
//               width:      '52%',
//               zIndex:     5,
//               overflow:   'hidden',
//               willChange: 'transform',
//             }}
//           >
//             {/* key forces remount if URL changes, same pattern as old OutroHero */}
//             <img
//               key={maskImage}
//               src={maskImage}
//               alt="outro visual"
//               style={{
//                 width:          '100%',
//                 height:         '100%',
//                 objectFit:      'contain',
//                 objectPosition: 'center',
//                 display:        'block',
//               }}
//               onError={e => { e.currentTarget.style.opacity = '0'; }}
//             />
//             {/* Gradient fades left edge of image into black */}
//             <div style={{
//               position:      'absolute',
//               inset:          0,
//               pointerEvents: 'none',
//               zIndex:         2,
//             }} />
//           </div>
//         )}

//         {/* ── Card stack — flies in from left ─────────────────── */}
//         <div style={{
//           position:       'absolute',
//           left:           0,
//           top:            0,
//           bottom:         0,
//           width:          isMobile ? '100%' : '58%',
//           display:        'flex',
//           alignItems:     'center',
//           justifyContent: 'center',
//           zIndex:         10,
//         }}>
//           {ITEMS.map((review, i) => (
//             <ReviewCard
//               key={review.id || i}
//               review={review}
//               ref={el => cardRefs.current[i] = el}
//               isMobile={isMobile}
//             />
//           ))}
//         </div>

//       </div>
//     </div>
//   );
// }

// // ─── CertImage ───────────────────────────────────────────────────
// function CertImage({ src, alt, color, title, issuer }) {
//   const imgRef  = useRef(null);
//   const fallRef = useRef(null);
//   const initials = (title || '').split(' ').slice(0, 2).map(w => w[0]).join('');

//   return (
//     <div style={{ position: 'relative', width: '100%', height: '100%' }}>
//       <img
//         ref={imgRef}
//         src={src}
//         alt={alt}
//         loading="eager"
//         decoding="async"
//         fetchPriority="high"
//         onError={() => {
//           if (imgRef.current)  imgRef.current.style.display  = 'none';
//           if (fallRef.current) fallRef.current.style.display = 'flex';
//         }}
//         style={{
//           width: '100%', height: '100%',
//           objectFit: 'contain', objectPosition: 'center',
//           display: 'block',
//         }}
//       />
//       <div ref={fallRef} style={{
//         display: 'none', position: 'absolute', inset: 0,
//         flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
//         gap: '0.75rem',
//       }}>
//         <span style={{
//           fontFamily: 'Syne, sans-serif', fontWeight: 800,
//           fontSize: '3rem', color: 'var(--white)', opacity: 0.15,
//         }}>{initials}</span>
//         <div style={{
//           fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: '0.85rem',
//           color: 'var(--white)', textAlign: 'center',
//           padding: '0 2rem', lineHeight: 1.25, opacity: 0.4,
//         }}>{title}</div>
//         <div style={{
//           fontFamily: 'Space Mono, monospace', fontSize: '0.55rem',
//           color: 'var(--muted)', letterSpacing: '0.18em', textTransform: 'uppercase',
//         }}>{issuer}</div>
//       </div>
//     </div>
//   );
// }

// // ─── ProgressRail ─────────────────────────────────────────────────
// function ProgressRail({ count, activeIndex, isMobile }) {
//   return (
//     <div style={{
//       position: 'absolute',
//       zIndex: 30,
//       left: '5vw', right: '5vw',
//       display: 'flex', gap: '6px', alignItems: 'center',
//       pointerEvents: 'none',
//       ...(isMobile
//         ? { top: `${HEADER_H + IMAGE_ZONE_H - 1}px`, bottom: 'auto' }
//         : { bottom: `${TICKER_H + 12}px`,            top:    'auto' }
//       ),
//     }}>
//       {Array.from({ length: count }).map((_, i) => (
//         <div key={i} style={{
//           flex: i === activeIndex ? 4 : 1,
//           height: '1px',
//           background: i === activeIndex ? 'var(--acid)' : '#222',
//           transition: 'flex 0.45s cubic-bezier(0.4,0,0.2,1), background 0.3s',
//         }} />
//       ))}
//     </div>
//   );
// }

// // ─── CertContent ─────────────────────────────────────────────────
// function CertContent({ cert, index, total, isMobile }) {
//   const level = LEVEL_MAP[cert.level] || LEVEL_MAP['Associate'];
//   const description = cert.desc || cert.description || '';
//   const skillTags = cert.tags || cert.skills || [];

//   return (
//     <div style={{
//       position: 'relative',
//       width: '100%', height: '100%',
//       display: 'flex', flexDirection: 'column', justifyContent: 'center',
//       padding: isMobile ? '1.2rem 6vw 1.2rem 8vw' : '2rem 5vw 2rem 5vw',
//       boxSizing: 'border-box',
//       overflow: 'hidden',
//     }}>
//       <div aria-hidden="true" style={{
//         position: 'absolute',
//         top: '50%', right: '-0.04em',
//         transform: 'translateY(-50%)',
//         fontFamily: 'Syne, sans-serif',
//         fontSize: isMobile ? 'clamp(26vw,33vw,40vw)' : 'clamp(16vw,20vw,26vw)',
//         fontWeight: 800,
//         color: cert.color,
//         opacity: 0.05,
//         lineHeight: 1,
//         userSelect: 'none', pointerEvents: 'none',
//         letterSpacing: '-0.06em',
//         zIndex: 0,
//       }}>{pad(index + 1)}</div>

//       <div style={{
//         position: 'absolute',
//         left: isMobile ? '4vw' : '2vw',
//         top: '10%', bottom: '10%',
//         width: '1px',
//         background: `linear-gradient(to bottom, transparent, ${cert.color}88, transparent)`,
//         zIndex: 1,
//       }} />

//       <div style={{ position: 'relative', zIndex: 2 }}>
//         <div style={{
//           display: 'flex', alignItems: 'center',
//           gap: '0.75rem',
//           marginBottom: isMobile ? '0.7rem' : '1.4rem',
//           flexWrap: 'wrap',
//         }}>
//           <span style={{
//             fontFamily: 'Space Mono, monospace',
//             fontSize: isMobile ? '0.65rem' : '0.75rem',
//             color: cert.color, letterSpacing: '0.2em', fontWeight: 700,
//           }}>
//             {pad(index + 1)} / {pad(total)}
//           </span>
//           <div style={{ width: 20, height: '1px', background: `${cert.color}55` }} />
//           <span style={{
//             fontFamily: 'Space Mono, monospace',
//             fontSize: '0.6rem', color: 'var(--muted)', letterSpacing: '0.12em',
//           }}>
//             {cert.issuer?.toUpperCase()}
//           </span>
//           {cert.year && (
//             <span style={{
//               fontFamily: 'Space Mono, monospace',
//               fontSize: '0.6rem', color: 'var(--muted)',
//               letterSpacing: '0.1em', marginLeft: 'auto',
//             }}>
//               {cert.year}
//             </span>
//           )}
//         </div>

//         <h2 style={{
//           fontFamily: 'Syne, sans-serif', fontWeight: 800,
//           fontSize: isMobile
//             ? 'clamp(1.25rem, 5.5vw, 2rem)'
//             : 'clamp(2rem, 4vw, 4.5rem)',
//           letterSpacing: '-0.04em', lineHeight: 1,
//           color: 'var(--white)',
//           margin: isMobile ? '0 0 0.7rem' : '0 0 1.2rem',
//         }}>
//           {cert.title}
//         </h2>

//         <div style={{
//           width: isMobile ? 'min(160px, 50vw)' : 'min(280px, 26vw)',
//           height: '1px',
//           background: `linear-gradient(90deg, ${cert.color} 0%, transparent 100%)`,
//           marginBottom: isMobile ? '0.7rem' : '1.2rem',
//         }} />

//         {cert.level && (
//           <div style={{
//             display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
//             background: level.bg, border: `1px solid ${level.border}`,
//             borderRadius: 4, padding: '0.25rem 0.65rem',
//             marginBottom: isMobile ? '0.7rem' : '1.3rem',
//           }}>
//             <span style={{
//               width: 5, height: 5, borderRadius: '50%',
//               background: level.text, display: 'inline-block', flexShrink: 0,
//             }} />
//             <span style={{
//               fontFamily: 'Space Mono, monospace', fontSize: '0.58rem',
//               letterSpacing: '0.12em', color: level.text,
//               textTransform: 'uppercase', fontWeight: 700,
//             }}>
//               {cert.level}
//             </span>
//           </div>
//         )}

//         {description && !isMobile && (
//           <p style={{
//             fontFamily: 'Space Mono, monospace', fontSize: '0.65rem',
//             color: 'var(--white)', lineHeight: 1.7,
//             margin: '0 0 1.2rem', maxWidth: '36ch',
//           }}>
//             {description}
//           </p>
//         )}

//         {skillTags.length > 0 && (
//           <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.35rem' }}>
//             {(isMobile ? skillTags.slice(0, 4) : skillTags).map((sk, si) => (
//               <span key={si} style={{
//                 fontFamily: 'Space Mono, monospace',
//                 fontSize: isMobile ? '0.52rem' : '0.58rem',
//                 padding: isMobile ? '0.2rem 0.5rem' : '0.25rem 0.7rem',
//                 background: `${cert.color}0a`, color: '#aaa',
//                 border: `1px solid ${cert.color}22`,
//                 borderRadius: 2, letterSpacing: '0.05em',
//               }}>
//                 {sk}
//               </span>
//             ))}
//           </div>
//         )}
//       </div>

//       <div style={{
//         position: 'absolute',
//         bottom: isMobile ? '0.8rem' : '2rem', right: '5vw',
//         width: 20, height: 20,
//         borderRight: '1px solid rgba(200,240,74,0.27)',
//         borderBottom: '1px solid rgba(200,240,74,0.27)',
//         zIndex: 2,
//       }} />
//     </div>
//   );
// }

// // ─── Main ─────────────────────────────────────────────────────────
// export default function Certificates({ loaded, isMobile }) {
//   const [certs,       setCerts]       = useState(null);
//   const [reviews,     setReviews]     = useState(null);
//   const [ready,       setReady]       = useState(false);
//   const [activeIndex, setActiveIndex] = useState(0);

//   // Outro image — maskImage from settings/certificates in Firestore
//   const [outroMaskImage, setOutroMaskImage] = useState('./mask.png');

//   // Three scroll-driven progress values:
//   // outroReveal    — drives the circle clip-path (0→1)
//   // outroImageProg — drives maskImage sliding in from right (0→1)
//   // outroCards     — drives review cards flying in from left (0→1)
//   const [outroReveal,    setOutroReveal]    = useState(0);
//   const [outroImageProg, setOutroImageProg] = useState(0);
//   const [outroCards,     setOutroCards]     = useState(0);

//   const sectionRef  = useRef(null);
//   const imgPanelRef = useRef(null);
//   const txtPanelRef = useRef(null);
//   const ctxRef      = useRef(null);

//   // ── Fetch certs + reviews + outro settings in parallel ─────────
//   useEffect(() => {
//     // Certificates
//     fetchCertificates()
//       .then(data => {
//         if (data?.length) {
//           preloadCertImages(data);
//           setCerts(data);
//         }
//       })
//       .catch(console.error);

//     // Reviews
//     fetchReviews()
//       .then(data => {
//         if (data?.length) setReviews(data);
//       })
//       .catch(console.error);

//     // Outro image — same fetch pattern as your old OutroHero code.
//     // Reads `maskImage` field from settings/certificates Firestore doc.
//     // cache: 'no-store' prevents stale URLs (same fix as your old code).
//     async function loadOutroSettings() {
//       try {
//         const res = await fetch(
//           `${REST_BASE}/settings/certificates?key=${API_KEY}`,
//           { cache: 'no-store' }
//         );
//         if (!res.ok) return;
//         const json = await res.json();
//         if (!json.fields) return;
//         const s = fromFields(json.fields);
//         if (s.maskImage) setOutroMaskImage(s.maskImage);
//       } catch (err) {
//         console.warn('fetchOutroSettings failed:', err);
//       }
//     }
//     loadOutroSettings();
//   }, []);

//   useEffect(() => {
//     if (loaded && certs) setReady(true);
//   }, [loaded, certs]);

//   // ── GSAP scroll ────────────────────────────────────────────────
//   useEffect(() => {
//     if (!ready) return;
//     const section  = sectionRef.current;
//     const imgPanel = imgPanelRef.current;
//     const txtPanel = txtPanelRef.current;
//     if (!section || !imgPanel || !txtPanel) return;

//     if (ctxRef.current) { ctxRef.current.revert(); ctxRef.current = null; }

//     ctxRef.current = gsap.context(() => {
//       const n = certs.length;

//       // ── Header reveal ─────────────────────────────────────────
//       gsap.set('.cv-header-h2',    { clipPath: 'inset(0 100% 0 0 round 4px)', skewX: -6 });
//       gsap.set('.cv-header-label', { opacity: 0, x: -24 });
//       gsap.timeline({
//         scrollTrigger: { trigger: section, start: 'top 85%', once: true },
//       })
//         .to('.cv-header-label', { opacity: 1, x: 0, duration: 0.6, ease: 'power3.out' })
//         .to('.cv-header-h2', {
//           clipPath: 'inset(0 0% 0 0 round 4px)', skewX: 0,
//           duration: 1.0, ease: 'expo.inOut',
//         }, '-=0.3');

//       const getImgW = () =>
//         imgPanel.parentElement?.offsetWidth ??
//         (isMobile ? window.innerWidth : window.innerWidth * 0.5);

//       const getTxtW = () =>
//         txtPanel.parentElement?.offsetWidth ??
//         (isMobile ? window.innerWidth : window.innerWidth * 0.5);

//       gsap.set(imgPanel, { x: 0 });
//       gsap.set(txtPanel, { x: 0 });

//       // ── Cert strip timelines ──────────────────────────────────
//       const tlImg = gsap.timeline({ paused: true });
//       tlImg.to(imgPanel, {
//         x: () => -(n - 1) * getImgW(),
//         ease: 'none', duration: n - 1,
//       });

//       const tlTxt = gsap.timeline({ paused: true });
//       tlTxt.to(txtPanel, {
//         x: () => -(n - 1) * getTxtW(),
//         ease: 'none', duration: n - 1,
//       });

//       // ── Outro circle-reveal timeline ──────────────────────────
//       gsap.set('.cv-outro-wrap', {
//         clipPath: 'circle(0px at 100% 100%)',
//         opacity:  1,
//       });

//       const tlOutro = gsap.timeline({ paused: true });
//       tlOutro.to('.cv-outro-wrap', {
//         clipPath: 'circle(150% at 100% 100%)',
//         ease: 'power2.inOut',
//         duration: 1,
//       });

//       // ── Scroll budget maths ───────────────────────────────────
//       const getStepH = () => window.innerHeight - HEADER_H;

//       const getCertEnd = () => {
//         const certBudget  = (n - 1) * getStepH() + getStepH() * 1.2;
//         const outroBudget = getStepH() * OUTRO_BUDGET;
//         return certBudget / (certBudget + outroBudget);
//       };

//       ScrollTrigger.create({
//         trigger: section,
//         start: 'top top',
//         end: () => {
//           const certBudget  = (n - 1) * getStepH() + getStepH() * 1.2;
//           const outroBudget = getStepH() * OUTRO_BUDGET;
//           return `+=${certBudget + outroBudget}`;
//         },
//         pin: true,
//         scrub: 3,
//         anticipatePin: 1,
//         invalidateOnRefresh: true,

//         onUpdate(self) {
//           const p       = self.progress;
//           const certEnd = getCertEnd();

//           // ── Cert strip ────────────────────────────────────────
//           const certP = Math.min(1, p / certEnd);
//           tlImg.progress(certP);
//           tlTxt.progress(certP);
//           const idx = Math.min(n - 1, Math.round(certP * (n - 1)));
//           setActiveIndex(idx);

//           // ── Raw outro progress (0→1 across the full outro budget)
//           const rawOutroP = certEnd >= 1
//             ? 0
//             : Math.max(0, (p - certEnd) / (1 - certEnd));

//           // ── Phase 1: Circle reveal (rawOutroP 0 → REVEAL_THRESHOLD) ──
//           const revealP = Math.min(1, rawOutroP / REVEAL_THRESHOLD);
//           tlOutro.progress(revealP);
//           setOutroReveal(revealP);

//           // ── Phases 2 & 3 only start after reveal is complete ─────────
//           const postRevealP = rawOutroP <= REVEAL_THRESHOLD
//             ? 0
//             : (rawOutroP - REVEAL_THRESHOLD) / (1 - REVEAL_THRESHOLD);

//           // ── Phase 2: maskImage slides in from right (0 → IMAGE_PHASE) ─
//           const imageP = Math.min(1, postRevealP / IMAGE_PHASE);
//           setOutroImageProg(imageP);

//           // ── Phase 3: Cards fly in from left (IMAGE_PHASE → 1.0) ───────
//           const cardP = postRevealP <= IMAGE_PHASE
//             ? 0
//             : (postRevealP - IMAGE_PHASE) / (1 - IMAGE_PHASE);
//           setOutroCards(cardP);

//           // Pointer events: enable once reveal has started
//           const outroEl = document.querySelector('.cv-outro-wrap');
//           if (outroEl) {
//             outroEl.style.pointerEvents = rawOutroP > 0.05 ? 'auto' : 'none';
//           }
//         },
//       });

//     }, section);

//     return () => {
//       if (ctxRef.current) { ctxRef.current.revert(); ctxRef.current = null; }
//     };
//   }, [ready, certs, isMobile]);

//   if (!certs || !ready) return null;

//   return (
//     <section
//       ref={sectionRef}
//       id="certificates"
//       style={{
//         background: 'var(--black)',
//         position: 'relative',
//         minHeight: '100vh',
//         overflow: 'hidden',
//         touchAction: 'pan-y',
//       }}
//     >
//       {/* ── HEADER STRIP ──────────────────────────────────────────── */}
//       <div style={{
//         position: 'absolute',
//         top: 0, left: 0, right: 0,
//         height: `${HEADER_H}px`,
//         zIndex: 20,
//         display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between',
//         padding: '0 5vw 1.2rem',
//         borderBottom: '1px solid #1a1a1a',
//         boxSizing: 'border-box',
//         background: 'var(--black)',
//         pointerEvents: 'none',
//       }}>
//         <div>
//           <div className="cv-header-label" style={{
//             display: 'flex', alignItems: 'center', gap: '0.6rem',
//             marginBottom: '1.5rem',
//           }}>
//             <span style={{
//               fontFamily: 'Space Mono, monospace', fontSize: '0.55rem',
//               color: 'var(--acid)', letterSpacing: '0.2em',
//             }}>05</span>
//             <div style={{ width: 24, height: '1px', background: 'var(--acid)', opacity: 0.4 }} />
//             <span style={{
//               fontFamily: 'Space Mono, monospace', fontSize: '0.55rem',
//               color: 'var(--acid)', letterSpacing: '0.18em', textTransform: 'uppercase',
//             }}>Credentials</span>
//           </div>
//           <h2 className="cv-header-h2" style={{
//             fontFamily: 'Syne, sans-serif', fontWeight: 800,
//             fontSize: isMobile ? 'clamp(1.4rem,5vw,2rem)' : 'clamp(1.6rem,3vw,3rem)',
//             letterSpacing: '-0.04em', lineHeight: 0.9,
//             margin: 0, color: 'var(--white)',
//           }}>
//             Earned{' '}<span style={{ color: 'var(--acid)' }}>Badges</span>
//           </h2>
//         </div>
//         <div style={{
//           fontFamily: 'Space Mono, monospace',
//           textAlign: 'right', pointerEvents: 'auto',
//         }}>
//           <span style={{
//             fontSize: isMobile ? '1.6rem' : '2.4rem',
//             fontWeight: 700, color: 'var(--acid)',
//             display: 'block', lineHeight: 1,
//           }}>
//             {pad(activeIndex + 1)}
//           </span>
//           <span style={{ fontSize: '0.55rem', color: '#444', letterSpacing: '0.12em' }}>
//             / {pad(certs.length)} CERTS
//           </span>
//         </div>
//       </div>

//       {/* ── PROGRESS RAIL ─────────────────────────────────────────── */}
//       <ProgressRail count={certs.length} activeIndex={activeIndex} isMobile={isMobile} />

//       {/* ── IMAGE STRIP VIEWPORT ──────────────────────────────────── */}
//       <div style={{
//         position: 'absolute',
//         top:    `${HEADER_H}px`,
//         left:   0,
//         width:  isMobile ? '100%' : '50%',
//         height: isMobile ? `${IMAGE_ZONE_H}px` : undefined,
//         bottom: isMobile ? undefined : `${TICKER_H}px`,
//         overflow: 'hidden',
//         zIndex: 5,
//       }}>
//         <div
//           ref={imgPanelRef}
//           style={{
//             display: 'flex', flexDirection: 'row',
//             width: `${certs.length * 100}%`,
//             height: '100%',
//             willChange: 'transform',
//           }}
//         >
//           {certs.map((cert, i) => (
//             <div
//               key={cert.id || i}
//               style={{
//                 width: `${100 / certs.length}%`,
//                 flexShrink: 0, height: '100%',
//                 display: 'flex', alignItems: 'center', justifyContent: 'center',
//                 padding: isMobile ? '1rem 8vw' : '2rem 3vw 2rem 5vw',
//                 boxSizing: 'border-box',
//               }}
//             >
//               <div style={{
//                 width: '100%',
//                 maxWidth: isMobile ? '80vw' : 500,
//                 aspectRatio: '4/3',
//                 overflow: 'hidden',
//               }}>
//                 <CertImage
//                   src={cert.src} alt={cert.title}
//                   color={cert.color} title={cert.title} issuer={cert.issuer}
//                 />
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* ── DIVIDER — desktop only ─────────────────────────────────── */}
//       {!isMobile && (
//         <div style={{
//           position: 'absolute',
//           top: `${HEADER_H}px`, bottom: `${TICKER_H}px`,
//           left: '50%', width: '1px',
//           background: 'linear-gradient(to bottom, #141414, #222 20%, #222 80%, #141414)',
//           zIndex: 8, pointerEvents: 'none',
//         }} />
//       )}

//       {/* ── TEXT STRIP VIEWPORT ───────────────────────────────────── */}
//       <div style={{
//         position: 'absolute',
//         top:    isMobile ? `${HEADER_H + IMAGE_ZONE_H}px` : `${HEADER_H}px`,
//         left:   isMobile ? 0 : '50%',
//         width:  isMobile ? '100%' : '50%',
//         height: isMobile ? MOBILE_TEXT_H : undefined,
//         bottom: isMobile ? undefined : `${TICKER_H}px`,
//         overflow: 'hidden',
//         zIndex: 10,
//       }}>
//         <div
//           ref={txtPanelRef}
//           style={{
//             display: 'flex', flexDirection: 'row',
//             width: `${certs.length * 100}%`,
//             height: '100%',
//             willChange: 'transform',
//           }}
//         >
//           {certs.map((cert, i) => (
//             <div
//               key={cert.id || i}
//               style={{
//                 width: `${100 / certs.length}%`,
//                 flexShrink: 0, height: '100%',
//               }}
//             >
//               <CertContent
//                 cert={cert}
//                 index={i}
//                 total={certs.length}
//                 isMobile={isMobile}
//               />
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* ── TICKER STRIP ──────────────────────────────────────────── */}
//       <div style={{
//         position: 'absolute',
//         bottom: 0, left: 0, right: 0,
//         height: `${TICKER_H}px`,
//         overflow: 'hidden',
//         borderTop: '1px solid #111',
//         display: 'flex', alignItems: 'center',
//         background: 'var(--black)', zIndex: 25,
//       }}>
//         <div style={{
//           display: 'flex', gap: '2rem', whiteSpace: 'nowrap',
//           animation: 'cv-ticker 30s linear infinite',
//         }}>
//           {[...certs, ...certs, ...certs, ...certs].map((c, i) => (
//             <span key={i} style={{
//               fontFamily: 'Syne, sans-serif', fontWeight: 700,
//               fontSize: '0.7rem', letterSpacing: '-0.01em',
//               color: i % 2 === 0 ? 'var(--white)' : `${c.color}`,
//             }}>
//               {c.title}
//               <span style={{ opacity: 0.15, marginLeft: '0.5rem' }}>·</span>
//             </span>
//           ))}
//         </div>
//       </div>

//       {/* ── OUTRO REVEAL ──────────────────────────────────────────── */}
//       {/*
//         Circle wipe expands first (outroReveal drives clip-path via tlOutro).
//         Then maskImage slides in from right (outroImageProg).
//         Then review cards fly in from left (outroCards).
//       */}
//       <div
//         className="cv-outro-wrap"
//         style={{
//           position:      'absolute',
//           top: 0, left: 0,
//           width:         '100%',
//           height:        '100%',
//           zIndex:        40,
//           overflow:      'hidden',
//           background:    'var(--black)',
//           pointerEvents: 'none',
//         }}
//       >
//         <OutroReviews
//           imageProgress={outroImageProg}
//           cardProgress={outroCards}
//           isMobile={isMobile}
//           reviews={reviews}
//           maskImage={outroMaskImage}
//         />
//       </div>

//       <style>{`
//         @keyframes cv-ticker {
//           from { transform: translateX(0); }
//           to   { transform: translateX(-50%); }
//         }
//       `}</style>
//     </section>
//   );
// }

// // // import { useEffect, useRef, useState } from 'react';
// // // import { gsap } from 'gsap';
// // // import { ScrollTrigger } from 'gsap/ScrollTrigger';
// // // import { fetchCertificates } from './data';

// // // // ─── IMPORTANT: Import REST_BASE and API_KEY from the correct path ────────────
// // // // Previously this imported from '../components/data' — adjust this path to match
// // // // your actual project structure. It should point to wherever REST_BASE/API_KEY live.
// // // import { REST_BASE, API_KEY } from './data';   // ← was '../components/data'

// // // gsap.registerPlugin(ScrollTrigger);

// // // const pad = n => String(n).padStart(2, '0');

// // // // ─── Constants ────────────────────────────────────────────────────
// // // const HEADER_H     = 120;
// // // const TICKER_H     = 36;
// // // const IMAGE_ZONE_H = 260;

// // // const DESKTOP_BLOCK_H = `calc(100vh - ${HEADER_H}px)`;
// // // const MOBILE_TEXT_H   = `calc(100vh - ${HEADER_H}px - ${IMAGE_ZONE_H}px - ${TICKER_H}px)`;
// // // const OUTRO_BUDGET    = 3.5;

// // // // ─── Firestore REST helpers ───────────────────────────────────────
// // // function fromValue(v) {
// // //   if (!v) return null;
// // //   if ('stringValue'  in v) return v.stringValue;
// // //   if ('integerValue' in v) return Number(v.integerValue);
// // //   if ('doubleValue'  in v) return Number(v.doubleValue);
// // //   if ('booleanValue' in v) return v.booleanValue;
// // //   if ('nullValue'    in v) return null;
// // //   if ('arrayValue'   in v) return (v.arrayValue.values || []).map(fromValue);
// // //   if ('mapValue'     in v) {
// // //     const o = {};
// // //     for (const [k, val] of Object.entries(v.mapValue.fields || {})) o[k] = fromValue(val);
// // //     return o;
// // //   }
// // //   return null;
// // // }
// // // function fromFields(fields) {
// // //   const o = {};
// // //   for (const [k, v] of Object.entries(fields)) o[k] = fromValue(v);
// // //   return o;
// // // }

// // // // ─── Fetch outro settings from Firestore ─────────────────────────
// // // // Reads `settings/certificates` document which is written by the admin panel.
// // // // Fields stored: { maskImage: string, revealImage: string }
// // // async function fetchOutroSettings() {
// // //   try {
// // //     const res = await fetch(`${REST_BASE}/settings/certificates?key=${API_KEY}`);
// // //     if (!res.ok) return null;
// // //     const json = await res.json();
// // //     if (!json.fields) return null;
// // //     return fromFields(json.fields);
// // //   } catch {
// // //     return null;
// // //   }
// // // }

// // // // ─── Level colour map ─────────────────────────────────────────────
// // // const LEVEL_MAP = {
// // //   Expert:       { bg: 'rgba(83,74,183,0.15)',  border: '#534AB7', text: '#AFA9EC' },
// // //   Professional: { bg: 'rgba(15,110,86,0.15)',  border: '#0F6E56', text: '#5DCAA5' },
// // //   Associate:    { bg: 'rgba(133,79,11,0.15)',  border: '#854F0B', text: '#EF9F27' },
// // // };

// // // // ─── Preload cert images ──────────────────────────────────────────
// // // function preloadCertImages(certs) {
// // //   certs.forEach(cert => {
// // //     if (!cert.src) return;
// // //     const img = new Image();
// // //     img.fetchPriority = 'auto';
// // //     img.src = cert.src;
// // //   });
// // // }

// // // // ─── CertImage ───────────────────────────────────────────────────
// // // function CertImage({ src, alt, color, title, issuer }) {
// // //   const imgRef  = useRef(null);
// // //   const fallRef = useRef(null);
// // //   const initials = (title || '').split(' ').slice(0, 2).map(w => w[0]).join('');

// // //   return (
// // //     <div style={{ position: 'relative', width: '100%', height: '100%' }}>
// // //       <img
// // //         ref={imgRef}
// // //         src={src}
// // //         alt={alt}
// // //         loading="eager"
// // //         decoding="async"
// // //         fetchPriority="high"
// // //         onError={() => {
// // //           if (imgRef.current)  imgRef.current.style.display  = 'none';
// // //           if (fallRef.current) fallRef.current.style.display = 'flex';
// // //         }}
// // //         style={{
// // //           width: '100%', height: '100%',
// // //           objectFit: 'contain', objectPosition: 'center',
// // //           display: 'block',
// // //         }}
// // //       />
// // //       <div ref={fallRef} style={{
// // //         display: 'none', position: 'absolute', inset: 0,
// // //         flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
// // //         gap: '0.75rem',
// // //       }}>
// // //         <span style={{
// // //           fontFamily: 'Syne, sans-serif', fontWeight: 800,
// // //           fontSize: '3rem', color: 'var(--white)', opacity: 0.15,
// // //         }}>{initials}</span>
// // //         <div style={{
// // //           fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: '0.85rem',
// // //           color: 'var(--white)', textAlign: 'center',
// // //           padding: '0 2rem', lineHeight: 1.25, opacity: 0.4,
// // //         }}>{title}</div>
// // //         <div style={{
// // //           fontFamily: 'Space Mono, monospace', fontSize: '0.55rem',
// // //           color: 'var(--muted)', letterSpacing: '0.18em', textTransform: 'uppercase',
// // //         }}>{issuer}</div>
// // //       </div>
// // //     </div>
// // //   );
// // // }

// // // // ─── ProgressRail ─────────────────────────────────────────────────
// // // function ProgressRail({ count, activeIndex, isMobile }) {
// // //   return (
// // //     <div style={{
// // //       position: 'absolute',
// // //       zIndex: 30,
// // //       left: '5vw', right: '5vw',
// // //       display: 'flex', gap: '6px', alignItems: 'center',
// // //       pointerEvents: 'none',
// // //       ...(isMobile
// // //         ? { top: `${HEADER_H + IMAGE_ZONE_H - 1}px`, bottom: 'auto' }
// // //         : { bottom: `${TICKER_H + 12}px`,            top:    'auto' }
// // //       ),
// // //     }}>
// // //       {Array.from({ length: count }).map((_, i) => (
// // //         <div key={i} style={{
// // //           flex: i === activeIndex ? 4 : 1,
// // //           height: '1px',
// // //           background: i === activeIndex ? 'var(--acid)' : '#222',
// // //           transition: 'flex 0.45s cubic-bezier(0.4,0,0.2,1), background 0.3s',
// // //         }} />
// // //       ))}
// // //     </div>
// // //   );
// // // }

// // // // ─── CertContent ─────────────────────────────────────────────────
// // // function CertContent({ cert, index, total, isMobile }) {
// // //   const level = LEVEL_MAP[cert.level] || LEVEL_MAP['Associate'];

// // //   // ── FIX 1: Admin saves `desc`, frontend was reading `description` ──
// // //   // Normalise: accept either field name so old and new data both work.
// // //   const description = cert.desc || cert.description || '';

// // //   // ── FIX 2: Admin saves `tags`, frontend was reading `skills` ──────
// // //   // Normalise: accept either field name.
// // //   const skillTags = cert.tags || cert.skills || [];

// // //   return (
// // //     <div style={{
// // //       position: 'relative',
// // //       width: '100%', height: '100%',
// // //       display: 'flex', flexDirection: 'column', justifyContent: 'center',
// // //       padding: isMobile ? '1.2rem 6vw 1.2rem 8vw' : '2rem 5vw 2rem 5vw',
// // //       boxSizing: 'border-box',
// // //       overflow: 'hidden',
// // //     }}>
// // //       <div aria-hidden="true" style={{
// // //         position: 'absolute',
// // //         top: '50%', right: '-0.04em',
// // //         transform: 'translateY(-50%)',
// // //         fontFamily: 'Syne, sans-serif',
// // //         fontSize: isMobile ? 'clamp(26vw,33vw,40vw)' : 'clamp(16vw,20vw,26vw)',
// // //         fontWeight: 800,
// // //         color: cert.color,
// // //         opacity: 0.05,
// // //         lineHeight: 1,
// // //         userSelect: 'none', pointerEvents: 'none',
// // //         letterSpacing: '-0.06em',
// // //         zIndex: 0,
// // //       }}>{pad(index + 1)}</div>

// // //       <div style={{
// // //         position: 'absolute',
// // //         left: isMobile ? '4vw' : '2vw',
// // //         top: '10%', bottom: '10%',
// // //         width: '1px',
// // //         background: `linear-gradient(to bottom, transparent, ${cert.color}88, transparent)`,
// // //         zIndex: 1,
// // //       }} />

// // //       <div style={{ position: 'relative', zIndex: 2 }}>
// // //         <div style={{
// // //           display: 'flex', alignItems: 'center',
// // //           gap: '0.75rem',
// // //           marginBottom: isMobile ? '0.7rem' : '1.4rem',
// // //           flexWrap: 'wrap',
// // //         }}>
// // //           <span style={{
// // //             fontFamily: 'Space Mono, monospace',
// // //             fontSize: isMobile ? '0.65rem' : '0.75rem',
// // //             color: cert.color, letterSpacing: '0.2em', fontWeight: 700,
// // //           }}>
// // //             {pad(index + 1)} / {pad(total)}
// // //           </span>
// // //           <div style={{ width: 20, height: '1px', background: `${cert.color}55` }} />
// // //           <span style={{
// // //             fontFamily: 'Space Mono, monospace',
// // //             fontSize: '0.6rem', color: 'var(--muted)', letterSpacing: '0.12em',
// // //           }}>
// // //             {cert.issuer?.toUpperCase()}
// // //           </span>
// // //           {cert.year && (
// // //             <span style={{
// // //               fontFamily: 'Space Mono, monospace',
// // //               fontSize: '0.6rem', color: 'var(--muted)',
// // //               letterSpacing: '0.1em', marginLeft: 'auto',
// // //             }}>
// // //               {cert.year}
// // //             </span>
// // //           )}
// // //         </div>

// // //         <h2 style={{
// // //           fontFamily: 'Syne, sans-serif', fontWeight: 800,
// // //           fontSize: isMobile
// // //             ? 'clamp(1.25rem, 5.5vw, 2rem)'
// // //             : 'clamp(2rem, 4vw, 4.5rem)',
// // //           letterSpacing: '-0.04em', lineHeight: 1,
// // //           color: 'var(--white)',
// // //           margin: isMobile ? '0 0 0.7rem' : '0 0 1.2rem',
// // //         }}>
// // //           {cert.title}
// // //         </h2>

// // //         <div style={{
// // //           width: isMobile ? 'min(160px, 50vw)' : 'min(280px, 26vw)',
// // //           height: '1px',
// // //           background: `linear-gradient(90deg, ${cert.color} 0%, transparent 100%)`,
// // //           marginBottom: isMobile ? '0.7rem' : '1.2rem',
// // //         }} />

// // //         {cert.level && (
// // //           <div style={{
// // //             display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
// // //             background: level.bg, border: `1px solid ${level.border}`,
// // //             borderRadius: 4, padding: '0.25rem 0.65rem',
// // //             marginBottom: isMobile ? '0.7rem' : '1.3rem',
// // //           }}>
// // //             <span style={{
// // //               width: 5, height: 5, borderRadius: '50%',
// // //               background: level.text, display: 'inline-block', flexShrink: 0,
// // //             }} />
// // //             <span style={{
// // //               fontFamily: 'Space Mono, monospace', fontSize: '0.58rem',
// // //               letterSpacing: '0.12em', color: level.text,
// // //               textTransform: 'uppercase', fontWeight: 700,
// // //             }}>
// // //               {cert.level}
// // //             </span>
// // //           </div>
// // //         )}

// // //         {/* FIX 1 applied: use normalised `description` instead of cert.description */}
// // //         {description && !isMobile && (
// // //           <p style={{
// // //             fontFamily: 'Space Mono, monospace', fontSize: '0.65rem',
// // //             color: 'var(--white)', lineHeight: 1.7,
// // //             margin: '0 0 1.2rem', maxWidth: '36ch',
// // //           }}>
// // //             {description}
// // //           </p>
// // //         )}

// // //         {/* FIX 2 applied: use normalised `skillTags` instead of cert.skills */}
// // //         {skillTags.length > 0 && (
// // //           <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.35rem' }}>
// // //             {(isMobile ? skillTags.slice(0, 4) : skillTags).map((sk, si) => (
// // //               <span key={si} style={{
// // //                 fontFamily: 'Space Mono, monospace',
// // //                 fontSize: isMobile ? '0.52rem' : '0.58rem',
// // //                 padding: isMobile ? '0.2rem 0.5rem' : '0.25rem 0.7rem',
// // //                 background: `${cert.color}0a`, color: '#aaa',
// // //                 border: `1px solid ${cert.color}22`,
// // //                 borderRadius: 2, letterSpacing: '0.05em',
// // //               }}>
// // //                 {sk}
// // //               </span>
// // //             ))}
// // //           </div>
// // //         )}
// // //       </div>

// // //       <div style={{
// // //         position: 'absolute',
// // //         bottom: isMobile ? '0.8rem' : '2rem', right: '5vw',
// // //         width: 20, height: 20,
// // //         borderRight: '1px solid rgba(200,240,74,0.27)',
// // //         borderBottom: '1px solid rgba(200,240,74,0.27)',
// // //         zIndex: 2,
// // //       }} />
// // //     </div>
// // //   );
// // // }

// // // // ─── Silhouette polygon points (% of container, centroid ≈ 50,50) ─
// // // const SILHOUETTE_PTS = [
// // //   [44, 0], [46, 3], [42, 5], [45, 7],
// // //   [50, 2], [55, 7], [53, 5], [56, 3],
// // //   [58, 0],
// // //   [68, 4], [72, 8], [65, 11],
// // //   [78, 14], [82, 18],
// // //   [88, 22], [84, 26], [90, 30], [85, 34],
// // //   [82, 42], [86, 48],
// // //   [88, 56], [82, 58],
// // //   [80, 68], [84, 74],
// // //   [86, 82], [80, 84], [83, 90],
// // //   [78, 98], [72, 100],
// // //   [58, 98], [52, 100], [50, 96],
// // //   [48, 100], [42, 98],
// // //   [37, 90], [40, 84], [34, 82],
// // //   [26, 74], [30, 68],
// // //   [28, 58], [22, 56],
// // //   [24, 48], [18, 42],
// // //   [15, 34], [20, 30], [16, 26], [12, 22],
// // //   [18, 18], [22, 14],
// // //   [35, 11], [28, 8], [32, 4],
// // //   [38, 2],
// // // ];

// // // const SHAPE_SCALE = 0.42;
// // // const SHAPE_CX = SILHOUETTE_PTS.reduce((s, [x]) => s + x, 0) / SILHOUETTE_PTS.length;
// // // const SHAPE_CY = SILHOUETTE_PTS.reduce((s, [, y]) => s + y, 0) / SILHOUETTE_PTS.length;

// // // // ─── buildPolygonClip ─────────────────────────────────────────────
// // // function buildPolygonClip(pts, cursorX, cursorY, progress, scale = 0.4) {
// // //   const interp = pts.map(([x, y]) => {
// // //     const dx = (x - SHAPE_CX) * scale;
// // //     const dy = (y - SHAPE_CY) * scale;
// // //     const nx = cursorX + dx * progress;
// // //     const ny = cursorY + dy * progress;
// // //     return `${nx.toFixed(2)}% ${ny.toFixed(2)}%`;
// // //   });
// // //   return `polygon(${interp.join(', ')})`;
// // // }

// // // // ─── OutroHero ────────────────────────────────────────────────────
// // // // maskImage   — always-visible desaturated base portrait
// // // // revealImage — full-colour image revealed inside the hover silhouette
// // // // Both are driven from Firestore settings/certificates via props.
// // // function OutroHero({
// // //   isMobile,
// // //   maskImage   = './mask.png',
// // //   revealImage = './desktop.png',
// // // }) {
// // //   const containerRef = useRef(null);
// // //   const revealImgRef = useRef(null);
// // //   const svgStrokeRef = useRef(null);
// // //   const rafRef       = useRef(null);

// // //   const stateRef = useRef({
// // //     mouseX:   50,
// // //     mouseY:   50,
// // //     curX:     50,
// // //     curY:     50,
// // //     progress: 0,
// // //     hovered:  false,
// // //   });

// // //   useEffect(() => {
// // //     const s      = stateRef.current;
// // //     const reveal = revealImgRef.current;
// // //     const stroke = svgStrokeRef.current;

// // //     function tick() {
// // //       const lf = 0.09;

// // //       s.curX += (s.mouseX - s.curX) * lf;
// // //       s.curY += (s.mouseY - s.curY) * lf;

// // //       const targetP = s.hovered ? 1 : 0;
// // //       s.progress += (targetP - s.progress) * lf;
// // //       if (Math.abs(s.progress - targetP) < 0.002) s.progress = targetP;

// // //       const clip = buildPolygonClip(SILHOUETTE_PTS, s.curX, s.curY, s.progress, 0.42);
// // //       if (reveal) {
// // //         reveal.style.clipPath       = clip;
// // //         reveal.style.webkitClipPath = clip;
// // //       }

// // //       if (stroke) {
// // //         stroke.style.opacity         = (s.progress * 0.9).toFixed(3);
// // //         stroke.style.transform       = `scale(${(0.97 + s.progress * 0.03).toFixed(3)})`;
// // //         stroke.style.transformOrigin = `${s.curX.toFixed(1)}% ${s.curY.toFixed(1)}%`;
// // //       }

// // //       const svgGroup = stroke?.querySelector('.cv-stroke-group');
// // //       if (svgGroup) {
// // //         const tx = (s.curX - SHAPE_CX).toFixed(2);
// // //         const ty = (s.curY - SHAPE_CY).toFixed(2);
// // //         svgGroup.setAttribute(
// // //           'transform',
// // //           `translate(${tx}, ${ty}) scale(${(s.progress * SHAPE_SCALE).toFixed(4)})`
// // //         );
// // //         svgGroup.style.transformOrigin = `${SHAPE_CX}% ${SHAPE_CY}%`;
// // //       }

// // //       rafRef.current = requestAnimationFrame(tick);
// // //     }

// // //     rafRef.current = requestAnimationFrame(tick);
// // //     return () => cancelAnimationFrame(rafRef.current);
// // //   }, []);

// // //   function getPercent(el, clientX, clientY) {
// // //     const r = el?.getBoundingClientRect();
// // //     if (!r) return null;
// // //     return {
// // //       x: ((clientX - r.left) / r.width)  * 100,
// // //       y: ((clientY - r.top)  / r.height) * 100,
// // //     };
// // //   }

// // //   function onMouseMove(e) {
// // //     const p = getPercent(containerRef.current, e.clientX, e.clientY);
// // //     if (p) { stateRef.current.mouseX = p.x; stateRef.current.mouseY = p.y; }
// // //   }
// // //   function onMouseEnter(e) {
// // //     const p = getPercent(containerRef.current, e.clientX, e.clientY);
// // //     if (p) {
// // //       stateRef.current.mouseX = stateRef.current.curX = p.x;
// // //       stateRef.current.mouseY = stateRef.current.curY = p.y;
// // //     }
// // //     stateRef.current.hovered = true;
// // //   }
// // //   function onMouseLeave() { stateRef.current.hovered = false; }

// // //   function onTouchMove(e) {
// // //     const t = e.touches[0];
// // //     const p = getPercent(containerRef.current, t.clientX, t.clientY);
// // //     if (p) { stateRef.current.mouseX = p.x; stateRef.current.mouseY = p.y; }
// // //   }
// // //   function onTouchStart(e) {
// // //     stateRef.current.hovered = true;
// // //     onTouchMove(e);
// // //   }
// // //   function onTouchEnd() { stateRef.current.hovered = false; }

// // //   const strokePath = SILHOUETTE_PTS.map(([x, y], i) =>
// // //     `${i === 0 ? 'M' : 'L'}${x},${y}`
// // //   ).join(' ') + ' Z';

// // //   const accentDots = [
// // //     [50, 2], [88, 22], [12, 22], [86, 82], [34, 82],
// // //   ];

// // //   return (
// // //     <div
// // //       ref={containerRef}
// // //       onMouseMove={onMouseMove}
// // //       onMouseEnter={onMouseEnter}
// // //       onMouseLeave={onMouseLeave}
// // //       onTouchMove={onTouchMove}
// // //       onTouchStart={onTouchStart}
// // //       onTouchEnd={onTouchEnd}
// // //       style={{
// // //         position: 'relative',
// // //         width: '100%', height: '100%',
// // //         overflow: 'hidden',
// // //         cursor: 'crosshair',
// // //         background: 'var(--black, #0a0a0a)',
// // //       }}
// // //     >
// // //       {/* Base image — always visible, desaturated */}
// // //       {/* FIX 3: maskImage prop is now live from Firestore — no cache issues */}
// // //       <img
// // //         key={maskImage}   /* key forces remount when URL changes */
// // //         src={maskImage}
// // //         alt="Portrait"
// // //         style={{
// // //           position: 'absolute', inset: 0,
// // //           width: '100%', height: '100%',
// // //           objectFit: 'cover', objectPosition: 'center',
// // //           display: 'block',
// // //         }}
// // //         onError={e => { e.currentTarget.style.opacity = '0'; }}
// // //       />

// // //       {/* Revealed image — clipped to the silhouette */}
// // //       {/* FIX 3: revealImage prop is now live from Firestore — key forces remount */}
// // //       <img
// // //         key={revealImage}   /* key forces remount when URL changes */
// // //         ref={revealImgRef}
// // //         src={revealImage}
// // //         alt="Portrait revealed"
// // //         style={{
// // //           position: 'absolute', inset: 0,
// // //           width: '100%', height: '100%',
// // //           objectFit: 'cover', objectPosition: 'center',
// // //           display: 'block',
// // //           clipPath:       `polygon(${SHAPE_CX}% ${SHAPE_CY}%, ${SHAPE_CX}% ${SHAPE_CY}%)`,
// // //           WebkitClipPath: `polygon(${SHAPE_CX}% ${SHAPE_CY}%, ${SHAPE_CX}% ${SHAPE_CY}%)`,
// // //           willChange: 'clip-path',
// // //         }}
// // //         onError={e => { e.currentTarget.style.opacity = '0'; }}
// // //       />

// // //       {/* SVG acid-green lightning outline */}
// // //       <svg
// // //         ref={svgStrokeRef}
// // //         viewBox="0 0 100 100"
// // //         preserveAspectRatio="none"
// // //         aria-hidden="true"
// // //         style={{
// // //           position: 'absolute', inset: 0,
// // //           width: '100%', height: '100%',
// // //           pointerEvents: 'none',
// // //           opacity: 0,
// // //           overflow: 'visible',
// // //           willChange: 'opacity, transform',
// // //         }}
// // //       >
// // //         <defs>
// // //           <filter id="cv-lightning-glow" x="-20%" y="-20%" width="140%" height="140%">
// // //             <feGaussianBlur stdDeviation="0.8" result="blur" />
// // //             <feMerge>
// // //               <feMergeNode in="blur" />
// // //               <feMergeNode in="SourceGraphic" />
// // //             </feMerge>
// // //           </filter>
// // //         </defs>

// // //         <g
// // //           className="cv-stroke-group"
// // //           transform={`translate(0, 0) scale(0)`}
// // //           style={{ transformOrigin: `${SHAPE_CX}px ${SHAPE_CY}px` }}
// // //         >
// // //           <path
// // //             d={strokePath}
// // //             fill="none"
// // //             strokeWidth="1.4"
// // //             strokeLinejoin="miter"
// // //             strokeLinecap="square"
// // //             opacity="0.25"
// // //             filter="url(#cv-lightning-glow)"
// // //           />
// // //           <path
// // //             d={strokePath}
// // //             fill="none"
// // //             stroke="var(--acid)"
// // //             strokeWidth="0.5"
// // //             strokeLinejoin="miter"
// // //             strokeLinecap="square"
// // //             opacity="1"
// // //           />
// // //           {accentDots.map(([x, y], i) => (
// // //             <circle
// // //               key={i}
// // //               cx={x} cy={y} r="0.8"
// // //               fill="var(--acid, #c8f04a)"
// // //               opacity="0.9"
// // //             />
// // //           ))}
// // //         </g>
// // //       </svg>

// // //       {/* Hover hint */}
// // //       <div style={{
// // //         position: 'absolute',
// // //         bottom: '2rem', left: '50%',
// // //         transform: 'translateX(-50%)',
// // //         fontFamily: 'Space Mono, monospace',
// // //         fontSize: '0.55rem',
// // //         letterSpacing: '0.2em',
// // //         color: 'rgba(200,240,74,0.35)',
// // //         textTransform: 'uppercase',
// // //         pointerEvents: 'none',
// // //         whiteSpace: 'nowrap',
// // //       }}>
// // //         hover to reveal
// // //       </div>
// // //     </div>
// // //   );
// // // }

// // // // ─── Main ─────────────────────────────────────────────────────────
// // // export default function Certificates({ loaded, isMobile }) {
// // //   const [certs,       setCerts]       = useState(null);
// // //   const [ready,       setReady]       = useState(false);
// // //   const [activeIndex, setActiveIndex] = useState(0);

// // //   // ── Outro image URLs — fetched from Firestore settings/certificates ───
// // //   const [outroImages, setOutroImages] = useState({
// // //     maskImage:   './mask.png',
// // //     revealImage: './desktop.png',
// // //   });

// // //   const sectionRef  = useRef(null);
// // //   const imgPanelRef = useRef(null);
// // //   const txtPanelRef = useRef(null);
// // //   const ctxRef      = useRef(null);

// // //   // ── Fetch certificates ─────────────────────────────────────────
// // //   useEffect(() => {
// // //     fetchCertificates()
// // //       .then(data => {
// // //         if (data?.length) {
// // //           preloadCertImages(data);
// // //           setCerts(data);
// // //         }
// // //       })
// // //       .catch(console.error);
// // //   }, []);

// // //   // ── FIX 4: Fetch outro settings on every mount (no stale cache) ──
// // //   // Previously the fetch was correct but the stale React state from a
// // //   // previous render could linger. The `cache: 'no-store'` header ensures
// // //   // the browser always hits Firestore instead of the HTTP cache.
// // //   useEffect(() => {
// // //     async function loadOutroSettings() {
// // //       try {
// // //         const res = await fetch(
// // //           `${REST_BASE}/settings/certificates?key=${API_KEY}`,
// // //           { cache: 'no-store' }   // ← prevent browser caching stale URLs
// // //         );
// // //         if (!res.ok) return;
// // //         const json = await res.json();
// // //         if (!json.fields) return;
// // //         const s = fromFields(json.fields);
// // //         setOutroImages({
// // //           maskImage:   s.maskImage   || './mask.png',
// // //           revealImage: s.revealImage || './desktop.png',
// // //         });
// // //       } catch (err) {
// // //         console.warn('fetchOutroSettings failed:', err);
// // //       }
// // //     }
// // //     loadOutroSettings();
// // //   }, []); // runs once on mount — Firestore has no stale data at this point

// // //   useEffect(() => {
// // //     if (loaded && certs) setReady(true);
// // //   }, [loaded, certs]);

// // //   // ── GSAP scroll ────────────────────────────────────────────────
// // //   useEffect(() => {
// // //     if (!ready) return;
// // //     const section  = sectionRef.current;
// // //     const imgPanel = imgPanelRef.current;
// // //     const txtPanel = txtPanelRef.current;
// // //     if (!section || !imgPanel || !txtPanel) return;

// // //     if (ctxRef.current) { ctxRef.current.revert(); ctxRef.current = null; }

// // //     ctxRef.current = gsap.context(() => {
// // //       const n = certs.length;

// // //       // ── Header reveal ─────────────────────────────────────────
// // //       gsap.set('.cv-header-h2',    { clipPath: 'inset(0 100% 0 0 round 4px)', skewX: -6 });
// // //       gsap.set('.cv-header-label', { opacity: 0, x: -24 });
// // //       gsap.timeline({
// // //         scrollTrigger: { trigger: section, start: 'top 85%', once: true },
// // //       })
// // //         .to('.cv-header-label', { opacity: 1, x: 0, duration: 0.6, ease: 'power3.out' })
// // //         .to('.cv-header-h2', {
// // //           clipPath: 'inset(0 0% 0 0 round 4px)', skewX: 0,
// // //           duration: 1.0, ease: 'expo.inOut',
// // //         }, '-=0.3');

// // //       const getImgW = () =>
// // //         imgPanel.parentElement?.offsetWidth ??
// // //         (isMobile ? window.innerWidth : window.innerWidth * 0.5);

// // //       const getTxtW = () =>
// // //         txtPanel.parentElement?.offsetWidth ??
// // //         (isMobile ? window.innerWidth : window.innerWidth * 0.5);

// // //       gsap.set(imgPanel, { x: 0 });
// // //       gsap.set(txtPanel, { x: 0 });

// // //       // ── Cert card strip timelines ─────────────────────────────
// // //       const tlImg = gsap.timeline({ paused: true });
// // //       tlImg.to(imgPanel, {
// // //         x: () => -(n - 1) * getImgW(),
// // //         ease: 'none', duration: n - 1,
// // //       });

// // //       const tlTxt = gsap.timeline({ paused: true });
// // //       tlTxt.to(txtPanel, {
// // //         x: () => -(n - 1) * getTxtW(),
// // //         ease: 'none', duration: n - 1,
// // //       });

// // //       // ── Outro reveal timeline ─────────────────────────────────
// // //       gsap.set('.cv-outro-wrap', {
// // //         clipPath: 'circle(0px at 100% 100%)',
// // //         opacity:  1,
// // //       });

// // //       const tlOutro = gsap.timeline({ paused: true });
// // //       tlOutro.to('.cv-outro-wrap', {
// // //         clipPath: 'circle(150% at 100% 100%)',
// // //         ease: 'power2.inOut',
// // //         duration: 1,
// // //       });

// // //       // ── Scroll budget maths ───────────────────────────────────
// // //       const getStepH = () => window.innerHeight - HEADER_H;

// // //       const getCertEnd = () => {
// // //         const certBudget  = (n - 1) * getStepH() + getStepH() * 1.2;
// // //         const outroBudget = getStepH() * OUTRO_BUDGET;
// // //         return certBudget / (certBudget + outroBudget);
// // //       };

// // //       ScrollTrigger.create({
// // //         trigger: section,
// // //         start: 'top top',
// // //         end: () => {
// // //           const certBudget  = (n - 1) * getStepH() + getStepH() * 1.2;
// // //           const outroBudget = getStepH() * OUTRO_BUDGET;
// // //           return `+=${certBudget + outroBudget}`;
// // //         },
// // //         pin: true,
// // //         scrub: 3,
// // //         anticipatePin: 1,
// // //         invalidateOnRefresh: true,

// // //         onUpdate(self) {
// // //           const p       = self.progress;
// // //           const certEnd = getCertEnd();

// // //           const certP = Math.min(1, p / certEnd);
// // //           tlImg.progress(certP);
// // //           tlTxt.progress(certP);
// // //           const idx = Math.min(n - 1, Math.round(certP * (n - 1)));
// // //           setActiveIndex(idx);

// // //           const outroP = certEnd >= 1
// // //             ? 0
// // //             : Math.max(0, (p - certEnd) / (1 - certEnd));
// // //           tlOutro.progress(outroP);

// // //           const outroEl = document.querySelector('.cv-outro-wrap');
// // //           if (outroEl) {
// // //             outroEl.style.pointerEvents = outroP > 0.05 ? 'auto' : 'none';
// // //           }
// // //         },
// // //       });

// // //     }, section);

// // //     return () => {
// // //       if (ctxRef.current) { ctxRef.current.revert(); ctxRef.current = null; }
// // //     };
// // //   }, [ready, certs, isMobile]);

// // //   if (!certs || !ready) return null;

// // //   return (
// // //     <section
// // //       ref={sectionRef}
// // //       id="certificates"
// // //       style={{
// // //         background: 'var(--black)',
// // //         position: 'relative',
// // //         minHeight: '100vh',
// // //         overflow: 'hidden',
// // //         touchAction: 'pan-y',
        
// // //       }}

// // //     >
// // //       {/* ── HEADER STRIP ──────────────────────────────────────────── */}
// // //       <div
      
// // //       style={{
// // //         position: 'absolute',
// // //         top: 0, left: 0, right: 0,
// // //         height: `${HEADER_H}px`,
// // //         zIndex: 20,
// // //         display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between',
// // //         padding: '0 5vw 1.2rem',
// // //         borderBottom: '1px solid #1a1a1a',
// // //         boxSizing: 'border-box',
// // //         background: 'var(--black)',
// // //         pointerEvents: 'none',
// // //       }}
      
// // //       >
// // //         <div>
// // //           <div className="cv-header-label" 

// // //           style={{
// // //             display: 'flex', alignItems: 'center', gap: '0.6rem',
// // //             marginBottom: '1.5rem',
// // //           }}>
// // //             <span style={{
// // //               fontFamily: 'Space Mono, monospace', fontSize: '0.55rem',
// // //               color: 'var(--acid)', letterSpacing: '0.2em',
// // //             }}>05</span>
// // //             <div style={{ width: 24, height: '1px', background: 'var(--acid)', opacity: 0.4 }} />
// // //             <span style={{
// // //               fontFamily: 'Space Mono, monospace', fontSize: '0.55rem',
// // //               color: 'var(--acid)', letterSpacing: '0.18em', textTransform: 'uppercase',
// // //             }}>Credentials</span>
// // //           </div>
// // //           <h2 className="cv-header-h2" style={{
// // //             fontFamily: 'Syne, sans-serif', fontWeight: 800,
// // //             fontSize: isMobile ? 'clamp(1.4rem,5vw,2rem)' : 'clamp(1.6rem,3vw,3rem)',
// // //             letterSpacing: '-0.04em', lineHeight: 0.9,
// // //             margin: 0, color: 'var(--white)',
// // //           }}>
// // //             Earned{' '}<span style={{ color: 'var(--acid)' }}>Badges</span>
// // //           </h2>
// // //         </div>
// // //         <div style={{
// // //           fontFamily: 'Space Mono, monospace',
// // //           textAlign: 'right', pointerEvents: 'auto',
// // //         }}>
// // //           <span style={{
// // //             fontSize: isMobile ? '1.6rem' : '2.4rem',
// // //             fontWeight: 700, color: 'var(--acid)',
// // //             display: 'block', lineHeight: 1,
// // //           }}>
// // //             {pad(activeIndex + 1)}
// // //           </span>
// // //           <span style={{ fontSize: '0.55rem', color: '#444', letterSpacing: '0.12em' }}>
// // //             / {pad(certs.length)} CERTS
// // //           </span>
// // //         </div>
// // //       </div>

// // //       {/* ── PROGRESS RAIL ─────────────────────────────────────────── */}
// // //       <ProgressRail count={certs.length} activeIndex={activeIndex} isMobile={isMobile} />

// // //       {/* ── IMAGE STRIP VIEWPORT ──────────────────────────────────── */}
// // //       <div style={{
// // //         position: 'absolute',
// // //         top:    `${HEADER_H}px`,
// // //         left:   0,
// // //         width:  isMobile ? '100%' : '50%',
// // //         height: isMobile ? `${IMAGE_ZONE_H}px` : undefined,
// // //         bottom: isMobile ? undefined : `${TICKER_H}px`,
// // //         overflow: 'hidden',
// // //         zIndex: 5,
// // //       }}>
// // //         <div
// // //           ref={imgPanelRef}
// // //           style={{
// // //             display: 'flex', flexDirection: 'row',
// // //             width: `${certs.length * 100}%`,
// // //             height: '100%',
// // //             willChange: 'transform',
// // //           }}
// // //         >
// // //           {certs.map((cert, i) => (
// // //             <div
// // //               key={cert.id || i}
// // //               style={{
// // //                 width: `${100 / certs.length}%`,
// // //                 flexShrink: 0, height: '100%',
// // //                 display: 'flex', alignItems: 'center', justifyContent: 'center',
// // //                 padding: isMobile ? '1rem 8vw' : '2rem 3vw 2rem 5vw',
// // //                 boxSizing: 'border-box',
// // //               }}
// // //             >
// // //               <div style={{
// // //                 width: '100%',
// // //                 maxWidth: isMobile ? '80vw' : 500,
// // //                 aspectRatio: '4/3',
// // //                 overflow: 'hidden',
// // //               }}>
// // //                 <CertImage
// // //                   src={cert.src} alt={cert.title}
// // //                   color={cert.color} title={cert.title} issuer={cert.issuer}
// // //                 />
// // //               </div>
// // //             </div>
// // //           ))}
// // //         </div>
// // //       </div>

// // //       {/* ── DIVIDER — desktop only ─────────────────────────────────── */}
// // //       {!isMobile && (
// // //         <div style={{
// // //           position: 'absolute',
// // //           top: `${HEADER_H}px`, bottom: `${TICKER_H}px`,
// // //           left: '50%', width: '1px',
// // //           background: 'linear-gradient(to bottom, #141414, #222 20%, #222 80%, #141414)',
// // //           zIndex: 8, pointerEvents: 'none',
// // //         }} />
// // //       )}

// // //       {/* ── TEXT STRIP VIEWPORT ───────────────────────────────────── */}
// // //       <div style={{
// // //         position: 'absolute',
// // //         top:    isMobile ? `${HEADER_H + IMAGE_ZONE_H}px` : `${HEADER_H}px`,
// // //         left:   isMobile ? 0 : '50%',
// // //         width:  isMobile ? '100%' : '50%',
// // //         height: isMobile ? MOBILE_TEXT_H : undefined,
// // //         bottom: isMobile ? undefined : `${TICKER_H}px`,
// // //         overflow: 'hidden',
// // //         zIndex: 10,
// // //       }}>
// // //         <div
// // //           ref={txtPanelRef}
// // //           style={{
// // //             display: 'flex', flexDirection: 'row',
// // //             width: `${certs.length * 100}%`,
// // //             height: '100%',
// // //             willChange: 'transform',
// // //           }}
// // //         >
// // //           {certs.map((cert, i) => (
// // //             <div
// // //               key={cert.id || i}
// // //               style={{
// // //                 width: `${100 / certs.length}%`,
// // //                 flexShrink: 0, height: '100%',
// // //               }}
// // //             >
// // //               <CertContent
// // //                 cert={cert}
// // //                 index={i}
// // //                 total={certs.length}
// // //                 isMobile={isMobile}
// // //               />
// // //             </div>
// // //           ))}
// // //         </div>
// // //       </div>

// // //       {/* ── TICKER STRIP ──────────────────────────────────────────── */}
// // //       <div style={{
// // //         position: 'absolute',
// // //         bottom: 0, left: 0, right: 0,
// // //         height: `${TICKER_H}px`,
// // //         overflow: 'hidden',
// // //         borderTop: '1px solid #111',
// // //         display: 'flex', alignItems: 'center',
// // //         background: 'var(--black)', zIndex: 25,
// // //       }}>
// // //         <div style={{
// // //           display: 'flex', gap: '2rem', whiteSpace: 'nowrap',
// // //           animation: 'cv-ticker 30s linear infinite',
// // //         }}>
// // //           {[...certs, ...certs, ...certs, ...certs].map((c, i) => (
// // //             <span key={i} style={{
// // //               fontFamily: 'Syne, sans-serif', fontWeight: 700,
// // //               fontSize: '0.7rem', letterSpacing: '-0.01em',
// // //               color: i % 2 === 0 ? 'var(--white)' : `${c.color}`,
// // //             }}>
// // //               {c.title}
// // //               <span style={{ opacity: 0.15, marginLeft: '0.5rem' }}>·</span>
// // //             </span>
// // //           ))}
// // //         </div>
// // //       </div>

// // //       {/* ── OUTRO REVEAL ──────────────────────────────────────────── */}
// // //       <div
// // //         className="cv-outro-wrap"
// // //         style={{
// // //           position: 'absolute',
// // //           top: 0, left: 0,
// // //           width: '100%', height: '100%',
// // //           zIndex: 40,
// // //           overflow: 'hidden',
// // //           background: 'var(--black)',
// // //           pointerEvents: 'none',
// // //         }}
// // //       >
// // //         {/*
// // //           FIX 3+4: OutroHero receives live image URLs from Firestore.
// // //           The `key` prop on each <img> inside OutroHero forces React to
// // //           remount the element whenever the URL changes, clearing any
// // //           previously cached/displayed image.
// // //         */}
// // //         <OutroHero
// // //           isMobile={isMobile}
// // //           maskImage={outroImages.maskImage}
// // //           revealImage={outroImages.revealImage}
// // //         />
// // //       </div>

// // //       <style>{`
// // //         @keyframes cv-ticker {
// // //           from { transform: translateX(0); }
// // //           to   { transform: translateX(-50%); }
// // //         }
// // //       `}</style>
// // //     </section>
// // //   );
// // // }


// // import { useEffect, useRef, useState, forwardRef } from 'react';
// // import { gsap } from 'gsap';
// // import { ScrollTrigger } from 'gsap/ScrollTrigger';
// // import { fetchCertificates, fetchReviews } from './data';

// // gsap.registerPlugin(ScrollTrigger);

// // const pad = n => String(n).padStart(2, '0');

// // // ─── Constants ────────────────────────────────────────────────────
// // const HEADER_H     = 120;
// // const TICKER_H     = 36;
// // const IMAGE_ZONE_H = 260;

// // const DESKTOP_BLOCK_H = `calc(100vh - ${HEADER_H}px)`;
// // const MOBILE_TEXT_H   = `calc(100vh - ${HEADER_H}px - ${IMAGE_ZONE_H}px - ${TICKER_H}px)`;
// // const OUTRO_BUDGET    = 3.5;

// // // Reveal completes at this fraction of outroProgress before cards start
// // const REVEAL_THRESHOLD = 0.35;

// // // ─── Level colour map ─────────────────────────────────────────────
// // const LEVEL_MAP = {
// //   Expert:       { bg: 'rgba(83,74,183,0.15)',  border: '#534AB7', text: '#AFA9EC' },
// //   Professional: { bg: 'rgba(15,110,86,0.15)',  border: '#0F6E56', text: '#5DCAA5' },
// //   Associate:    { bg: 'rgba(133,79,11,0.15)',  border: '#854F0B', text: '#EF9F27' },
// // };

// // // ─── Preload cert images ──────────────────────────────────────────
// // function preloadCertImages(certs) {
// //   certs.forEach(cert => {
// //     if (!cert.src) return;
// //     const img = new Image();
// //     img.fetchPriority = 'auto';
// //     img.src = cert.src;
// //   });
// // }

// // // ─── Fallback reviews (shown if Firestore returns nothing) ────────
// // const FALLBACK_REVIEWS = [
// //   {
// //     id: '01',
// //     name: 'Arju',
// //     role: 'Founder, Orbit Labs',
// //     text: 'Naveen has a rare instinct for turning vague briefs into something that feels inevitable. Every animation, every hover state — nothing felt like a default.',
// //     tag: 'UI/UX',
// //     year: '2024',
// //   },
// //   {
// //     id: '02',
// //     name: 'Sarah Lindström',
// //     role: 'Creative Director, Helix Studio',
// //     text: 'The portfolio site he built us stopped people mid-scroll. We got three new client inquiries the week it launched, all citing the site directly.',
// //     tag: 'Frontend Dev',
// //     year: '2024',
// //   },
// //   {
// //     id: '03',
// //     name: 'Kabir Nair',
// //     role: 'CTO, Stackfield',
// //     text: 'Technically sharp and visually fluent — an unusual combination. He rebuilt our admin panel from the ground up and the performance gains were immediate.',
// //     tag: 'Full Stack',
// //     year: '2023',
// //   },
// //   {
// //     id: '04',
// //     name: 'Priya Rajan',
// //     role: 'Head of Product, Nomad OS',
// //     text: 'What stood out was the attention to micro-interactions. Every transition felt earned. He pushed back on two of my ideas and was right both times.',
// //     tag: 'Product Design',
// //     year: '2023',
// //   },
// //   {
// //     id: '05',
// //     name: 'Tom Breckenridge',
// //     role: 'Lead Engineer, Vanta Systems',
// //     text: 'Clean, maintainable React. The GSAP work was surgical — no bloat, no jank. Rare to find someone who cares about the code as much as the output.',
// //     tag: 'React / GSAP',
// //     year: '2023',
// //   },
// // ];

// // const TILTS   = [-4, 2.5, -1.5, 3, -2, -3.5, 1.8, -2.2, 3.5, -1];
// // const OFFSETS = [0, -6, 4, -3, 5, -4, 3, -5, 2, -2];

// // // ─── Easing ───────────────────────────────────────────────────────
// // function easeOutBack(t) {
// //   const c1 = 1.70158;
// //   const c3 = c1 + 1;
// //   return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2);
// // }

// // // ─── ReviewCard ───────────────────────────────────────────────────
// // const ReviewCard = forwardRef(function ReviewCard({ review, isMobile }, ref) {
// //   const cardW = isMobile ? 'min(82vw, 340px)' : '86vw';

// //   return (
// //     <div
// //       ref={ref}
// //       style={{
// //         position:     'absolute',
// //         width:        cardW,
// //         background:   'var(--black)',
// //         border:       '1px solid var(--border)',
// //         borderRadius: '6px',
// //         padding:      isMobile ? '1.4rem 1.2rem' : '2.2rem 2rem',
// //         boxSizing:    'border-box',
// //         willChange:   'transform',
// //       }}
// //     >
// //       {/* Top row: index + tag */}
// //       <div style={{
// //         display:        'flex',
// //         justifyContent: 'space-between',
// //         alignItems:     'center',
// //         marginBottom:   isMobile ? '1rem' : '1.6rem',
// //       }}>
// //         <span style={{
// //           fontFamily:    'Space Mono, monospace',
// //           fontSize:      '1rem',
// //           color:         'var(--acid)',
// //           letterSpacing: '0.18em',
// //           textTransform: 'uppercase',
// //           border:        '1px solid var(--border)',
// //           borderRadius:  '2px',
// //           padding:       '0.2rem 0.5rem',
// //         }}>
// //           {review.tag}
// //         </span>
// //       </div>

// //       {/* Quote mark */}
// //       <div style={{
// //         fontFamily:   'Syne, sans-serif',
// //         fontSize:     isMobile ? '2.4rem' : '3.5rem',
// //         lineHeight:   0.7,
// //         color:        'var(--white)',
// //         marginBottom: isMobile ? '0.6rem' : '0.8rem',
// //         userSelect:   'none',
// //       }}>
// //         "
// //       </div>

// //       {/* Review text */}
// //       <p style={{
// //         fontFamily:   'Space Mono, monospace',
// //         fontSize:     isMobile
// //           ? 'clamp(0.5rem, 2.2vw, 0.65rem)'
// //           : 'clamp(0.6rem, 1vw, 0.78rem)',
// //         lineHeight:   1.8,
// //         color:        'var(--white)',
// //         opacity:      0.75,
// //         margin:       0,
// //         marginBottom: isMobile ? '1.2rem' : '2rem',
// //       }}>
// //         {review.text}
// //       </p>

// //       {/* Divider */}
// //       <div style={{ height: '1px', background: 'var(--black)', marginBottom: isMobile ? '0.8rem' : '1.2rem' }} />

// //       {/* Reviewer info */}
// //       <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
// //         <div>
// //           <div style={{
// //             fontFamily:    'Syne, sans-serif',
// //             fontSize:      isMobile ? '0.6rem' : '0.75rem',
// //             fontWeight:    700,
// //             color:         'var(--white)',
// //             letterSpacing: '-0.02em',
// //             marginBottom:  '0.15rem',
// //           }}>
// //             {review.name}
// //           </div>
// //           <div style={{
// //             fontFamily:    'Space Mono, monospace',
// //             fontSize:      '1rem',
// //           color:         'var(--dummy)',
// //             letterSpacing: '0.06em',
// //           }}>
// //             {review.role}
// //           </div>
// //         </div>

// //         <span style={{
// //           fontFamily:    'Space Mono, monospace',
// //           fontSize:      '1rem',
// //           color:         'var(--dummy)',
// //           letterSpacing: '0.1em',
// //         }}>
// //           {review.year}
// //         </span>
// //       </div>
// //     </div>
// //   );
// // });

// // // ─── OutroReviews ─────────────────────────────────────────────────
// // // cardProgress is 0→1 and only starts AFTER the reveal is complete.
// // // reviews prop comes from Firestore; falls back to FALLBACK_REVIEWS.
// // function OutroReviews({ cardProgress, isMobile, reviews: reviewsProp }) {
// //   const cardRefs    = useRef([]);
// //   const progressRef = useRef(0);
// //   const rafRef      = useRef(null);

// //   // Use Firestore data when available, fall back to hardcoded list
// //   const ITEMS = (reviewsProp && reviewsProp.length > 0) ? reviewsProp : FALLBACK_REVIEWS;
// //   const total = ITEMS.length;

// //   // Keep a live ref so the rAF loop always reads the latest value
// //   useEffect(() => {
// //     progressRef.current = cardProgress;
// //   }, [cardProgress]);

// //   // One-time: set initial off-screen positions
// //   useEffect(() => {
// //     cardRefs.current.forEach((card, i) => {
// //       if (!card) return;
// //       gsap.set(card, {
// //         x:        '120vw',
// //         y:        OFFSETS[i] ?? 0,
// //         rotation: TILTS[i]  ?? 0,
// //         zIndex:   i,
// //         opacity:  1,
// //       });
// //     });
// //   }, [ITEMS.length]); // re-run if item count changes (Firestore loads after mount)

// //   // Drive cards via rAF so they respond instantly to scroll updates
// //   useEffect(() => {
// //     function tick() {
// //       const p = progressRef.current;
// //       cardRefs.current.forEach((card, i) => {
// //         if (!card) return;
// //         const landStart = i / total;
// //         const landP     = Math.max(0, Math.min(1, (p - landStart) / (1 / total)));
// //         const eL        = easeOutBack(landP);
// //         gsap.set(card, {
// //           x:        window.innerWidth * 1.2 * (1 - eL),
// //           y:        OFFSETS[i] ?? 0,
// //           rotation: TILTS[i]  ?? 0,
// //           zIndex:   i,
// //         });
// //       });
// //       rafRef.current = requestAnimationFrame(tick);
// //     }
// //     rafRef.current = requestAnimationFrame(tick);
// //     return () => cancelAnimationFrame(rafRef.current);
// //   }, [total]);

// //   return (
// //     <div style={{
// //       width: '100%', height: '100%',
// //       background: 'var(--black, #0a0a0a)',
// //       display: 'flex',
// //       flexDirection: 'column',
// //       overflow: 'hidden',
// //       position: 'relative',
// //     }}>
// //       {/* ── Header ──────────────────────────────────────────────── */}
// //       <div style={{
// //         padding:    isMobile ? '2rem 5vw 2rem' : '2rem 5vw 2rem',
// //         flexShrink: 0,
// //         position:   'relative',
// //         zIndex:     20,
// //       }}>

// //         <div style={{
// //           display:        'flex',
// //           alignItems:     isMobile ? 'flex-start' : 'baseline',
// //           flexDirection:  isMobile ? 'column' : 'row',
// //           justifyContent: 'center',
// //           gap:            isMobile ? '0.4rem' : '1rem',
// //           marginBottom:   isMobile ? '1rem' : '1rem',
// //         }}>
// //           <div style={{
// //             fontFamily:    'Syne, sans-serif',
// //             fontSize:      isMobile
// //               ? 'clamp(1rem, 8vw, 1.2rem)'
// //               : 'clamp(1rem, 4vw, 1.2rem)',
// //             fontWeight:    800,
// //             letterSpacing: '-0.05em',
// //             lineHeight:    0.9,
// //             textAlign:"center",
// //             color:         'var(--white)',
// //           }}>
// //             Kind <span style={{ color: 'var(--acid)' }}>Words</span>
// //           </div>

// //           {/* <div style={{
// //             fontFamily:    'Space Mono, monospace',
// //             fontSize:      isMobile ? '0.44rem' : '0.5rem',
// //             color:         '#333',
// //             letterSpacing: '0.18em',
// //             textTransform: 'uppercase',
// //           }}>
// //             {ITEMS.length} testimonials
// //           </div> */}
// //         </div>
// // <p
// //   style={{
// //     textAlign: "center",
// //     color: "var(--muted)",
// //     maxWidth: "700px",
// //     margin: "0 auto",
// //     lineHeight: "1.6",
// //   }}
// // >
// //   Feedback from founders, clients, and teams.
// // </p>
// //       </div>

// //       {/* ── Card stack ──────────────────────────────────────────── */}
// //       <div style={{
// //         flex:           1,
// //         position:       'relative',
// //         display:        'flex',
// //         alignItems:     'center',
// //         justifyContent: 'center',
// //         overflow:       'hidden',
// //         zIndex:         10,
// //       }}>
// //         {ITEMS.map((review, i) => (
// //           <ReviewCard
// //             key={review.id || i}
// //             review={review}
// //             ref={el => cardRefs.current[i] = el}
// //             isMobile={isMobile}
// //           />
// //         ))}
// //       </div>

// //       {/* ── Footer hint ─────────────────────────────────────────── */}
// //     </div>
// //   );
// // }

// // // ─── CertImage ───────────────────────────────────────────────────
// // function CertImage({ src, alt, color, title, issuer }) {
// //   const imgRef  = useRef(null);
// //   const fallRef = useRef(null);
// //   const initials = (title || '').split(' ').slice(0, 2).map(w => w[0]).join('');

// //   return (
// //     <div style={{ position: 'relative', width: '100%', height: '100%' }}>
// //       <img
// //         ref={imgRef}
// //         src={src}
// //         alt={alt}
// //         loading="eager"
// //         decoding="async"
// //         fetchPriority="high"
// //         onError={() => {
// //           if (imgRef.current)  imgRef.current.style.display  = 'none';
// //           if (fallRef.current) fallRef.current.style.display = 'flex';
// //         }}
// //         style={{
// //           width: '100%', height: '100%',
// //           objectFit: 'contain', objectPosition: 'center',
// //           display: 'block',
// //         }}
// //       />
// //       <div ref={fallRef} style={{
// //         display: 'none', position: 'absolute', inset: 0,
// //         flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
// //         gap: '0.75rem',
// //       }}>
// //         <span style={{
// //           fontFamily: 'Syne, sans-serif', fontWeight: 800,
// //           fontSize: '3rem', color: 'var(--white)', opacity: 0.15,
// //         }}>{initials}</span>
// //         <div style={{
// //           fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: '0.85rem',
// //           color: 'var(--white)', textAlign: 'center',
// //           padding: '0 2rem', lineHeight: 1.25, opacity: 0.4,
// //         }}>{title}</div>
// //         <div style={{
// //           fontFamily: 'Space Mono, monospace', fontSize: '0.55rem',
// //           color: 'var(--muted)', letterSpacing: '0.18em', textTransform: 'uppercase',
// //         }}>{issuer}</div>
// //       </div>
// //     </div>
// //   );
// // }

// // // ─── ProgressRail ─────────────────────────────────────────────────
// // function ProgressRail({ count, activeIndex, isMobile }) {
// //   return (
// //     <div style={{
// //       position: 'absolute',
// //       zIndex: 30,
// //       left: '5vw', right: '5vw',
// //       display: 'flex', gap: '6px', alignItems: 'center',
// //       pointerEvents: 'none',
// //       ...(isMobile
// //         ? { top: `${HEADER_H + IMAGE_ZONE_H - 1}px`, bottom: 'auto' }
// //         : { bottom: `${TICKER_H + 12}px`,            top:    'auto' }
// //       ),
// //     }}>
// //       {Array.from({ length: count }).map((_, i) => (
// //         <div key={i} style={{
// //           flex: i === activeIndex ? 4 : 1,
// //           height: '1px',
// //           background: i === activeIndex ? 'var(--acid)' : '#222',
// //           transition: 'flex 0.45s cubic-bezier(0.4,0,0.2,1), background 0.3s',
// //         }} />
// //       ))}
// //     </div>
// //   );
// // }

// // // ─── CertContent ─────────────────────────────────────────────────
// // function CertContent({ cert, index, total, isMobile }) {
// //   const level = LEVEL_MAP[cert.level] || LEVEL_MAP['Associate'];
// //   const description = cert.desc || cert.description || '';
// //   const skillTags = cert.tags || cert.skills || [];

// //   return (
// //     <div style={{
// //       position: 'relative',
// //       width: '100%', height: '100%',
// //       display: 'flex', flexDirection: 'column', justifyContent: 'center',
// //       padding: isMobile ? '1.2rem 6vw 1.2rem 8vw' : '2rem 5vw 2rem 5vw',
// //       boxSizing: 'border-box',
// //       overflow: 'hidden',
// //     }}>
// //       <div aria-hidden="true" style={{
// //         position: 'absolute',
// //         top: '50%', right: '-0.04em',
// //         transform: 'translateY(-50%)',
// //         fontFamily: 'Syne, sans-serif',
// //         fontSize: isMobile ? 'clamp(26vw,33vw,40vw)' : 'clamp(16vw,20vw,26vw)',
// //         fontWeight: 800,
// //         color: cert.color,
// //         opacity: 0.05,
// //         lineHeight: 1,
// //         userSelect: 'none', pointerEvents: 'none',
// //         letterSpacing: '-0.06em',
// //         zIndex: 0,
// //       }}>{pad(index + 1)}</div>

// //       <div style={{
// //         position: 'absolute',
// //         left: isMobile ? '4vw' : '2vw',
// //         top: '10%', bottom: '10%',
// //         width: '1px',
// //         background: `linear-gradient(to bottom, transparent, ${cert.color}88, transparent)`,
// //         zIndex: 1,
// //       }} />

// //       <div style={{ position: 'relative', zIndex: 2 }}>
// //         <div style={{
// //           display: 'flex', alignItems: 'center',
// //           gap: '0.75rem',
// //           marginBottom: isMobile ? '0.7rem' : '1.4rem',
// //           flexWrap: 'wrap',
// //         }}>
// //           <span style={{
// //             fontFamily: 'Space Mono, monospace',
// //             fontSize: isMobile ? '0.65rem' : '0.75rem',
// //             color: cert.color, letterSpacing: '0.2em', fontWeight: 700,
// //           }}>
// //             {pad(index + 1)} / {pad(total)}
// //           </span>
// //           <div style={{ width: 20, height: '1px', background: `${cert.color}55` }} />
// //           <span style={{
// //             fontFamily: 'Space Mono, monospace',
// //             fontSize: '0.6rem', color: 'var(--muted)', letterSpacing: '0.12em',
// //           }}>
// //             {cert.issuer?.toUpperCase()}
// //           </span>
// //           {cert.year && (
// //             <span style={{
// //               fontFamily: 'Space Mono, monospace',
// //               fontSize: '0.6rem', color: 'var(--muted)',
// //               letterSpacing: '0.1em', marginLeft: 'auto',
// //             }}>
// //               {cert.year}
// //             </span>
// //           )}
// //         </div>

// //         <h2 style={{
// //           fontFamily: 'Syne, sans-serif', fontWeight: 800,
// //           fontSize: isMobile
// //             ? 'clamp(1.25rem, 5.5vw, 2rem)'
// //             : 'clamp(2rem, 4vw, 4.5rem)',
// //           letterSpacing: '-0.04em', lineHeight: 1,
// //           color: 'var(--white)',
// //           margin: isMobile ? '0 0 0.7rem' : '0 0 1.2rem',
// //         }}>
// //           {cert.title}
// //         </h2>

// //         <div style={{
// //           width: isMobile ? 'min(160px, 50vw)' : 'min(280px, 26vw)',
// //           height: '1px',
// //           background: `linear-gradient(90deg, ${cert.color} 0%, transparent 100%)`,
// //           marginBottom: isMobile ? '0.7rem' : '1.2rem',
// //         }} />

// //         {cert.level && (
// //           <div style={{
// //             display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
// //             background: level.bg, border: `1px solid ${level.border}`,
// //             borderRadius: 4, padding: '0.25rem 0.65rem',
// //             marginBottom: isMobile ? '0.7rem' : '1.3rem',
// //           }}>
// //             <span style={{
// //               width: 5, height: 5, borderRadius: '50%',
// //               background: level.text, display: 'inline-block', flexShrink: 0,
// //             }} />
// //             <span style={{
// //               fontFamily: 'Space Mono, monospace', fontSize: '0.58rem',
// //               letterSpacing: '0.12em', color: level.text,
// //               textTransform: 'uppercase', fontWeight: 700,
// //             }}>
// //               {cert.level}
// //             </span>
// //           </div>
// //         )}

// //         {description && !isMobile && (
// //           <p style={{
// //             fontFamily: 'Space Mono, monospace', fontSize: '0.65rem',
// //             color: 'var(--white)', lineHeight: 1.7,
// //             margin: '0 0 1.2rem', maxWidth: '36ch',
// //           }}>
// //             {description}
// //           </p>
// //         )}

// //         {skillTags.length > 0 && (
// //           <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.35rem' }}>
// //             {(isMobile ? skillTags.slice(0, 4) : skillTags).map((sk, si) => (
// //               <span key={si} style={{
// //                 fontFamily: 'Space Mono, monospace',
// //                 fontSize: isMobile ? '0.52rem' : '0.58rem',
// //                 padding: isMobile ? '0.2rem 0.5rem' : '0.25rem 0.7rem',
// //                 background: `${cert.color}0a`, color: '#aaa',
// //                 border: `1px solid ${cert.color}22`,
// //                 borderRadius: 2, letterSpacing: '0.05em',
// //               }}>
// //                 {sk}
// //               </span>
// //             ))}
// //           </div>
// //         )}
// //       </div>

// //       <div style={{
// //         position: 'absolute',
// //         bottom: isMobile ? '0.8rem' : '2rem', right: '5vw',
// //         width: 20, height: 20,
// //         borderRight: '1px solid rgba(200,240,74,0.27)',
// //         borderBottom: '1px solid rgba(200,240,74,0.27)',
// //         zIndex: 2,
// //       }} />
// //     </div>
// //   );
// // }

// // // ─── Main ─────────────────────────────────────────────────────────
// // export default function Certificates({ loaded, isMobile }) {
// //   const [certs,       setCerts]       = useState(null);
// //   const [reviews,     setReviews]     = useState(null);   // ← Firestore reviews
// //   const [ready,       setReady]       = useState(false);
// //   const [activeIndex, setActiveIndex] = useState(0);

// //   // Two separate progress values:
// //   // outroReveal  — drives the clip-path (0→1)
// //   // outroCards   — drives the card fly-in (0→1), starts AFTER reveal is done
// //   const [outroReveal, setOutroReveal] = useState(0);
// //   const [outroCards,  setOutroCards]  = useState(0);

// //   const sectionRef  = useRef(null);
// //   const imgPanelRef = useRef(null);
// //   const txtPanelRef = useRef(null);
// //   const ctxRef      = useRef(null);

// //   // ── Fetch certificates + reviews in parallel ───────────────────
// //   useEffect(() => {
// //     fetchCertificates()
// //       .then(data => {
// //         if (data?.length) {
// //           preloadCertImages(data);
// //           setCerts(data);
// //         }
// //       })
// //       .catch(console.error);

// //     fetchReviews()
// //       .then(data => {
// //         if (data?.length) setReviews(data);
// //       })
// //       .catch(console.error);
// //   }, []);

// //   useEffect(() => {
// //     if (loaded && certs) setReady(true);
// //   }, [loaded, certs]);

// //   // ── GSAP scroll ────────────────────────────────────────────────
// //   useEffect(() => {
// //     if (!ready) return;
// //     const section  = sectionRef.current;
// //     const imgPanel = imgPanelRef.current;
// //     const txtPanel = txtPanelRef.current;
// //     if (!section || !imgPanel || !txtPanel) return;

// //     if (ctxRef.current) { ctxRef.current.revert(); ctxRef.current = null; }

// //     ctxRef.current = gsap.context(() => {
// //       const n = certs.length;

// //       // ── Header reveal ─────────────────────────────────────────
// //       gsap.set('.cv-header-h2',    { clipPath: 'inset(0 100% 0 0 round 4px)', skewX: -6 });
// //       gsap.set('.cv-header-label', { opacity: 0, x: -24 });
// //       gsap.timeline({
// //         scrollTrigger: { trigger: section, start: 'top 85%', once: true },
// //       })
// //         .to('.cv-header-label', { opacity: 1, x: 0, duration: 0.6, ease: 'power3.out' })
// //         .to('.cv-header-h2', {
// //           clipPath: 'inset(0 0% 0 0 round 4px)', skewX: 0,
// //           duration: 1.0, ease: 'expo.inOut',
// //         }, '-=0.3');

// //       const getImgW = () =>
// //         imgPanel.parentElement?.offsetWidth ??
// //         (isMobile ? window.innerWidth : window.innerWidth * 0.5);

// //       const getTxtW = () =>
// //         txtPanel.parentElement?.offsetWidth ??
// //         (isMobile ? window.innerWidth : window.innerWidth * 0.5);

// //       gsap.set(imgPanel, { x: 0 });
// //       gsap.set(txtPanel, { x: 0 });

// //       // ── Cert card strip timelines ─────────────────────────────
// //       const tlImg = gsap.timeline({ paused: true });
// //       tlImg.to(imgPanel, {
// //         x: () => -(n - 1) * getImgW(),
// //         ease: 'none', duration: n - 1,
// //       });

// //       const tlTxt = gsap.timeline({ paused: true });
// //       tlTxt.to(txtPanel, {
// //         x: () => -(n - 1) * getTxtW(),
// //         ease: 'none', duration: n - 1,
// //       });

// //       // ── Outro reveal timeline (clip-path only) ────────────────
// //       gsap.set('.cv-outro-wrap', {
// //         clipPath: 'circle(0px at 100% 100%)',
// //         opacity:  1,
// //       });

// //       const tlOutro = gsap.timeline({ paused: true });
// //       tlOutro.to('.cv-outro-wrap', {
// //         clipPath: 'circle(150% at 100% 100%)',
// //         ease: 'power2.inOut',
// //         duration: 1,
// //       });

// //       // ── Scroll budget maths ───────────────────────────────────
// //       const getStepH = () => window.innerHeight - HEADER_H;

// //       const getCertEnd = () => {
// //         const certBudget  = (n - 1) * getStepH() + getStepH() * 1.2;
// //         const outroBudget = getStepH() * OUTRO_BUDGET;
// //         return certBudget / (certBudget + outroBudget);
// //       };

// //       ScrollTrigger.create({
// //         trigger: section,
// //         start: 'top top',
// //         end: () => {
// //           const certBudget  = (n - 1) * getStepH() + getStepH() * 1.2;
// //           const outroBudget = getStepH() * OUTRO_BUDGET;
// //           return `+=${certBudget + outroBudget}`;
// //         },
// //         pin: true,
// //         scrub: 3,
// //         anticipatePin: 1,
// //         invalidateOnRefresh: true,

// //         onUpdate(self) {
// //           const p       = self.progress;
// //           const certEnd = getCertEnd();

// //           // ── Cert strip progress ───────────────────────────────
// //           const certP = Math.min(1, p / certEnd);
// //           tlImg.progress(certP);
// //           tlTxt.progress(certP);
// //           const idx = Math.min(n - 1, Math.round(certP * (n - 1)));
// //           setActiveIndex(idx);

// //           // ── Raw outro progress (0→1 across the outro budget) ──
// //           const rawOutroP = certEnd >= 1
// //             ? 0
// //             : Math.max(0, (p - certEnd) / (1 - certEnd));

// //           // ── Reveal progress: occupies first REVEAL_THRESHOLD ──
// //           const revealP = Math.min(1, rawOutroP / REVEAL_THRESHOLD);
// //           tlOutro.progress(revealP);
// //           setOutroReveal(revealP);

// //           // ── Card progress: starts only after reveal is complete
// //           const cardP = rawOutroP <= REVEAL_THRESHOLD
// //             ? 0
// //             : (rawOutroP - REVEAL_THRESHOLD) / (1 - REVEAL_THRESHOLD);
// //           setOutroCards(cardP);

// //           // pointer-events: enable once reveal has started
// //           const outroEl = document.querySelector('.cv-outro-wrap');
// //           if (outroEl) {
// //             outroEl.style.pointerEvents = rawOutroP > 0.05 ? 'auto' : 'none';
// //           }
// //         },
// //       });

// //     }, section);

// //     return () => {
// //       if (ctxRef.current) { ctxRef.current.revert(); ctxRef.current = null; }
// //     };
// //   }, [ready, certs, isMobile]);

// //   if (!certs || !ready) return null;

// //   return (
// //     <section
// //       ref={sectionRef}
// //       id="certificates"
// //       style={{
// //         background: 'var(--black)',
// //         position: 'relative',
// //         minHeight: '100vh',
// //         overflow: 'hidden',
// //         touchAction: 'pan-y',
// //       }}
// //     >
// //       {/* ── HEADER STRIP ──────────────────────────────────────────── */}
// //       <div style={{
// //         position: 'absolute',
// //         top: 0, left: 0, right: 0,
// //         height: `${HEADER_H}px`,
// //         zIndex: 20,
// //         display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between',
// //         padding: '0 5vw 1.2rem',
// //         borderBottom: '1px solid #1a1a1a',
// //         boxSizing: 'border-box',
// //         background: 'var(--black)',
// //         pointerEvents: 'none',
// //       }}>
// //         <div>
// //           <div className="cv-header-label" style={{
// //             display: 'flex', alignItems: 'center', gap: '0.6rem',
// //             marginBottom: '1.5rem',
// //           }}>
// //             <span style={{
// //               fontFamily: 'Space Mono, monospace', fontSize: '0.55rem',
// //               color: 'var(--acid)', letterSpacing: '0.2em',
// //             }}>05</span>
// //             <div style={{ width: 24, height: '1px', background: 'var(--acid)', opacity: 0.4 }} />
// //             <span style={{
// //               fontFamily: 'Space Mono, monospace', fontSize: '0.55rem',
// //               color: 'var(--acid)', letterSpacing: '0.18em', textTransform: 'uppercase',
// //             }}>Credentials</span>
// //           </div>
// //           <h2 className="cv-header-h2" style={{
// //             fontFamily: 'Syne, sans-serif', fontWeight: 800,
// //             fontSize: isMobile ? 'clamp(1.4rem,5vw,2rem)' : 'clamp(1.6rem,3vw,3rem)',
// //             letterSpacing: '-0.04em', lineHeight: 0.9,
// //             margin: 0, color: 'var(--white)',
// //           }}>
// //             Earned{' '}<span style={{ color: 'var(--acid)' }}>Badges</span>
// //           </h2>
// //         </div>
// //         <div style={{
// //           fontFamily: 'Space Mono, monospace',
// //           textAlign: 'right', pointerEvents: 'auto',
// //         }}>
// //           <span style={{
// //             fontSize: isMobile ? '1.6rem' : '2.4rem',
// //             fontWeight: 700, color: 'var(--acid)',
// //             display: 'block', lineHeight: 1,
// //           }}>
// //             {pad(activeIndex + 1)}
// //           </span>
// //           <span style={{ fontSize: '0.55rem', color: '#444', letterSpacing: '0.12em' }}>
// //             / {pad(certs.length)} CERTS
// //           </span>
// //         </div>
// //       </div>

// //       {/* ── PROGRESS RAIL ─────────────────────────────────────────── */}
// //       <ProgressRail count={certs.length} activeIndex={activeIndex} isMobile={isMobile} />

// //       {/* ── IMAGE STRIP VIEWPORT ──────────────────────────────────── */}
// //       <div style={{
// //         position: 'absolute',
// //         top:    `${HEADER_H}px`,
// //         left:   0,
// //         width:  isMobile ? '100%' : '50%',
// //         height: isMobile ? `${IMAGE_ZONE_H}px` : undefined,
// //         bottom: isMobile ? undefined : `${TICKER_H}px`,
// //         overflow: 'hidden',
// //         zIndex: 5,
// //       }}>
// //         <div
// //           ref={imgPanelRef}
// //           style={{
// //             display: 'flex', flexDirection: 'row',
// //             width: `${certs.length * 100}%`,
// //             height: '100%',
// //             willChange: 'transform',
// //           }}
// //         >
// //           {certs.map((cert, i) => (
// //             <div
// //               key={cert.id || i}
// //               style={{
// //                 width: `${100 / certs.length}%`,
// //                 flexShrink: 0, height: '100%',
// //                 display: 'flex', alignItems: 'center', justifyContent: 'center',
// //                 padding: isMobile ? '1rem 8vw' : '2rem 3vw 2rem 5vw',
// //                 boxSizing: 'border-box',
// //               }}
// //             >
// //               <div style={{
// //                 width: '100%',
// //                 maxWidth: isMobile ? '80vw' : 500,
// //                 aspectRatio: '4/3',
// //                 overflow: 'hidden',
// //               }}>
// //                 <CertImage
// //                   src={cert.src} alt={cert.title}
// //                   color={cert.color} title={cert.title} issuer={cert.issuer}
// //                 />
// //               </div>
// //             </div>
// //           ))}
// //         </div>
// //       </div>

// //       {/* ── DIVIDER — desktop only ─────────────────────────────────── */}
// //       {!isMobile && (
// //         <div style={{
// //           position: 'absolute',
// //           top: `${HEADER_H}px`, bottom: `${TICKER_H}px`,
// //           left: '50%', width: '1px',
// //           background: 'linear-gradient(to bottom, #141414, #222 20%, #222 80%, #141414)',
// //           zIndex: 8, pointerEvents: 'none',
// //         }} />
// //       )}

// //       {/* ── TEXT STRIP VIEWPORT ───────────────────────────────────── */}
// //       <div style={{
// //         position: 'absolute',
// //         top:    isMobile ? `${HEADER_H + IMAGE_ZONE_H}px` : `${HEADER_H}px`,
// //         left:   isMobile ? 0 : '50%',
// //         width:  isMobile ? '100%' : '50%',
// //         height: isMobile ? MOBILE_TEXT_H : undefined,
// //         bottom: isMobile ? undefined : `${TICKER_H}px`,
// //         overflow: 'hidden',
// //         zIndex: 10,
// //       }}>
// //         <div
// //           ref={txtPanelRef}
// //           style={{
// //             display: 'flex', flexDirection: 'row',
// //             width: `${certs.length * 100}%`,
// //             height: '100%',
// //             willChange: 'transform',
// //           }}
// //         >
// //           {certs.map((cert, i) => (
// //             <div
// //               key={cert.id || i}
// //               style={{
// //                 width: `${100 / certs.length}%`,
// //                 flexShrink: 0, height: '100%',
// //               }}
// //             >
// //               <CertContent
// //                 cert={cert}
// //                 index={i}
// //                 total={certs.length}
// //                 isMobile={isMobile}
// //               />
// //             </div>
// //           ))}
// //         </div>
// //       </div>

// //       {/* ── TICKER STRIP ──────────────────────────────────────────── */}
// //       <div style={{
// //         position: 'absolute',
// //         bottom: 0, left: 0, right: 0,
// //         height: `${TICKER_H}px`,
// //         overflow: 'hidden',
// //         borderTop: '1px solid #111',
// //         display: 'flex', alignItems: 'center',
// //         background: 'var(--black)', zIndex: 25,
// //       }}>
// //         <div style={{
// //           display: 'flex', gap: '2rem', whiteSpace: 'nowrap',
// //           animation: 'cv-ticker 30s linear infinite',
// //         }}>
// //           {[...certs, ...certs, ...certs, ...certs].map((c, i) => (
// //             <span key={i} style={{
// //               fontFamily: 'Syne, sans-serif', fontWeight: 700,
// //               fontSize: '0.7rem', letterSpacing: '-0.01em',
// //               color: i % 2 === 0 ? 'var(--white)' : `${c.color}`,
// //             }}>
// //               {c.title}
// //               <span style={{ opacity: 0.15, marginLeft: '0.5rem' }}>·</span>
// //             </span>
// //           ))}
// //         </div>
// //       </div>

// //       {/* ── OUTRO REVEAL — black screen with Reviews card stack ───── */}
// //       <div
// //         className="cv-outro-wrap"
// //         style={{
// //           position: 'absolute',
// //           top: 0, left: 0,
// //           width: '100%', height: '100%',
// //           zIndex: 40,
// //           overflow: 'hidden',
// //           background: 'var(--black)',
// //           pointerEvents: 'none',
// //         }}
// //       >
// //         {/* Pass Firestore reviews; component falls back to FALLBACK_REVIEWS if null */}
// //         <OutroReviews
// //           cardProgress={outroCards}
// //           isMobile={isMobile}
// //           reviews={reviews}
// //         />
// //       </div>

// //       <style>{`
// //         @keyframes cv-ticker {
// //           from { transform: translateX(0); }
// //           to   { transform: translateX(-50%); }
// //         }
// //       `}</style>
// //     </section>
// //   );
// // }





// // import { useEffect, useRef, useState, forwardRef } from 'react';
// // import { gsap } from 'gsap';
// // import { ScrollTrigger } from 'gsap/ScrollTrigger';
// // import { fetchCertificates, fetchReviews } from './data';

// // gsap.registerPlugin(ScrollTrigger);

// // const pad = n => String(n).padStart(2, '0');

// // // ─── Constants ────────────────────────────────────────────────────
// // const HEADER_H     = 120;
// // const TICKER_H     = 36;
// // const IMAGE_ZONE_H = 260;

// // const DESKTOP_BLOCK_H = `calc(100vh - ${HEADER_H}px)`;
// // const MOBILE_TEXT_H   = `calc(100vh - ${HEADER_H}px - ${IMAGE_ZONE_H}px - ${TICKER_H}px)`;
// // const OUTRO_BUDGET    = 3.5;

// // // Reveal completes at this fraction of outroProgress before phases start
// // const REVEAL_THRESHOLD = 0.35;

// // // Within cardProgress: image occupies first IMAGE_PHASE, then cards
// // const IMAGE_PHASE = 0.45;

// // // ─── Level colour map ─────────────────────────────────────────────
// // const LEVEL_MAP = {
// //   Expert:       { bg: 'rgba(83,74,183,0.15)',  border: '#534AB7', text: '#AFA9EC' },
// //   Professional: { bg: 'rgba(15,110,86,0.15)',  border: '#0F6E56', text: '#5DCAA5' },
// //   Associate:    { bg: 'rgba(133,79,11,0.15)',  border: '#854F0B', text: '#EF9F27' },
// // };

// // // ─── Preload cert images ──────────────────────────────────────────
// // function preloadCertImages(certs) {
// //   certs.forEach(cert => {
// //     if (!cert.src) return;
// //     const img = new Image();
// //     img.fetchPriority = 'auto';
// //     img.src = cert.src;
// //   });
// // }

// // // ─── Fallback reviews ─────────────────────────────────────────────
// // const FALLBACK_REVIEWS = [
// //   {
// //     id: '01',
// //     name: 'Arju',
// //     role: 'Founder, Orbit Labs',
// //     text: 'Naveen has a rare instinct for turning vague briefs into something that feels inevitable. Every animation, every hover state — nothing felt like a default.',
// //     tag: 'UI/UX',
// //     year: '2024',
// //   },
// //   {
// //     id: '02',
// //     name: 'Sarah Lindström',
// //     role: 'Creative Director, Helix Studio',
// //     text: 'The portfolio site he built us stopped people mid-scroll. We got three new client inquiries the week it launched, all citing the site directly.',
// //     tag: 'Frontend Dev',
// //     year: '2024',
// //   },
// //   {
// //     id: '03',
// //     name: 'Kabir Nair',
// //     role: 'CTO, Stackfield',
// //     text: 'Technically sharp and visually fluent — an unusual combination. He rebuilt our admin panel from the ground up and the performance gains were immediate.',
// //     tag: 'Full Stack',
// //     year: '2023',
// //   },
// //   {
// //     id: '04',
// //     name: 'Priya Rajan',
// //     role: 'Head of Product, Nomad OS',
// //     text: 'What stood out was the attention to micro-interactions. Every transition felt earned. He pushed back on two of my ideas and was right both times.',
// //     tag: 'Product Design',
// //     year: '2023',
// //   },
// //   {
// //     id: '05',
// //     name: 'Tom Breckenridge',
// //     role: 'Lead Engineer, Vanta Systems',
// //     text: 'Clean, maintainable React. The GSAP work was surgical — no bloat, no jank. Rare to find someone who cares about the code as much as the output.',
// //     tag: 'React / GSAP',
// //     year: '2023',
// //   },
// // ];

// // const TILTS   = [-4, 2.5, -1.5, 3, -2, -3.5, 1.8, -2.2, 3.5, -1];
// // const OFFSETS = [0, -6, 4, -3, 5, -4, 3, -5, 2, -2];

// // // ─── Easing ───────────────────────────────────────────────────────
// // function easeOutBack(t) {
// //   const c1 = 1.70158;
// //   const c3 = c1 + 1;
// //   return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2);
// // }

// // // ─── ReviewCard ───────────────────────────────────────────────────
// // const ReviewCard = forwardRef(function ReviewCard({ review, isMobile }, ref) {
// //   const cardW = isMobile ? 'min(82vw, 340px)' : '40vw';

// //   return (
// //     <div
// //       ref={ref}
// //       style={{
// //         position:     'absolute',
// //         width:        cardW,
// //         background:   'var(--black)',
// //         border:       '1px solid var(--border)',
// //         borderRadius: '6px',
// //         padding:      isMobile ? '1.4rem 1.2rem' : '2.2rem 2rem',
// //         boxSizing:    'border-box',
// //         willChange:   'transform',
// //       }}
// //     >
// //       {/* Top row: tag */}
// //       <div style={{
// //         display:        'flex',
// //         justifyContent: 'space-between',
// //         alignItems:     'center',
// //         marginBottom:   isMobile ? '1rem' : '1.6rem',
// //       }}>
// //         <span style={{
// //           fontFamily:    'Space Mono, monospace',
// //           fontSize:      '1rem',
// //           color:         'var(--acid)',
// //           letterSpacing: '0.18em',
// //           textTransform: 'uppercase',
// //           border:        '1px solid var(--border)',
// //           borderRadius:  '2px',
// //           padding:       '0.2rem 0.5rem',
// //         }}>
// //           {review.tag}
// //         </span>
// //       </div>

// //       {/* Quote mark */}
// //       <div style={{
// //         fontFamily:   'Syne, sans-serif',
// //         fontSize:     isMobile ? '2.4rem' : '3.5rem',
// //         lineHeight:   0.7,
// //         color:        'var(--white)',
// //         marginBottom: isMobile ? '0.6rem' : '0.8rem',
// //         userSelect:   'none',
// //       }}>
// //         "
// //       </div>

// //       {/* Review text */}
// //       <p style={{
// //         fontFamily:   'Space Mono, monospace',
// //         fontSize:     isMobile
// //           ? 'clamp(0.5rem, 2.2vw, 0.65rem)'
// //           : 'clamp(0.6rem, 1vw, 0.78rem)',
// //         lineHeight:   1.8,
// //         color:        'var(--white)',
// //         opacity:      0.75,
// //         margin:       0,
// //         marginBottom: isMobile ? '1.2rem' : '2rem',
// //       }}>
// //         {review.text}
// //       </p>

// //       {/* Divider */}
// //       <div style={{ height: '1px', background: 'var(--border)', marginBottom: isMobile ? '0.8rem' : '1.2rem' }} />

// //       {/* Reviewer info */}
// //       <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
// //         <div>
// //           <div style={{
// //             fontFamily:    'Syne, sans-serif',
// //             fontSize:      isMobile ? '0.6rem' : '0.75rem',
// //             fontWeight:    700,
// //             color:         'var(--white)',
// //             letterSpacing: '-0.02em',
// //             marginBottom:  '0.15rem',
// //           }}>
// //             {review.name}
// //           </div>
// //           <div style={{
// //             fontFamily:    'Space Mono, monospace',
// //             fontSize:      '0.6rem',
// //             color:         'var(--dummy)',
// //             letterSpacing: '0.06em',
// //           }}>
// //             {review.role}
// //           </div>
// //         </div>

// //         <span style={{
// //           fontFamily:    'Space Mono, monospace',
// //           fontSize:      '0.6rem',
// //           color:         'var(--dummy)',
// //           letterSpacing: '0.1em',
// //         }}>
// //           {review.year}
// //         </span>
// //       </div>
// //     </div>
// //   );
// // });

// // // ─── OutroReviews ─────────────────────────────────────────────────
// // function OutroReviews({ imageProgress, cardProgress, isMobile, reviews: reviewsProp, imageSrc }) {
// //   const cardRefs    = useRef([]);
// //   const imgWrapRef  = useRef(null);
// //   const progressRef = useRef({ img: 0, card: 0 });
// //   const rafRef      = useRef(null);

// //   const ITEMS = (reviewsProp && reviewsProp.length > 0) ? reviewsProp : FALLBACK_REVIEWS;
// //   const total = ITEMS.length;

// //   // Keep live ref for rAF loop
// //   useEffect(() => {
// //     progressRef.current = { img: imageProgress, card: cardProgress };
// //   }, [imageProgress, cardProgress]);

// //   // One-time: set initial off-screen positions
// //   useEffect(() => {
// //     // Cards start off-screen LEFT
// //     cardRefs.current.forEach((card, i) => {
// //       if (!card) return;
// //       gsap.set(card, {
// //         x:        '-120vw',
// //         y:        OFFSETS[i] ?? 0,
// //         rotation: TILTS[i]  ?? 0,
// //         zIndex:   i,
// //         opacity:  1,
// //       });
// //     });
// //     // Image starts off-screen RIGHT
// //     if (imgWrapRef.current) {
// //       gsap.set(imgWrapRef.current, { x: '110vw' });
// //     }
// //   }, [ITEMS.length]);

// //   // rAF loop driving image + cards
// //   useEffect(() => {
// //     function tick() {
// //       const { img: imgP, card: cardP } = progressRef.current;

// //       // Image slides in from right
// //       if (imgWrapRef.current) {
// //         const eImg = easeOutBack(Math.min(1, imgP));
// //         gsap.set(imgWrapRef.current, {
// //           x: window.innerWidth * 1.1 * (1 - eImg),
// //         });
// //       }

// //       // Cards fly in from left
// //       cardRefs.current.forEach((card, i) => {
// //         if (!card) return;
// //         const landStart = i / total;
// //         const landP     = Math.max(0, Math.min(1, (cardP - landStart) / (1 / total)));
// //         const eL        = easeOutBack(landP);
// //         gsap.set(card, {
// //           x:        -window.innerWidth * 1.2 * (1 - eL),
// //           y:        OFFSETS[i] ?? 0,
// //           rotation: TILTS[i]  ?? 0,
// //           zIndex:   i,
// //         });
// //       });

// //       rafRef.current = requestAnimationFrame(tick);
// //     }
// //     rafRef.current = requestAnimationFrame(tick);
// //     return () => cancelAnimationFrame(rafRef.current);
// //   }, [total]);

// //   return (
// //     <div style={{
// //       width:          '100%',
// //       height:         '100%',
// //       background:     'var(--black, #0a0a0a)',
// //       display:        'flex',
// //       flexDirection:  'column',
// //       overflow:       'hidden',
// //       position:       'relative',
// //     }}>

// //       {/* ── Header ──────────────────────────────────────────────── */}
// //       <div style={{
// //         padding:    '2rem 5vw 1.5rem',
// //         flexShrink: 0,
// //         position:   'relative',
// //         zIndex:     20,
// //       }}>
// //         <div style={{
// //           display:        'flex',
// //           alignItems:     isMobile ? 'flex-start' : 'baseline',
// //           flexDirection:  isMobile ? 'row' : 'row',
// //           justifyContent: 'center',
// //           gap:            isMobile ? '0.4rem' : '1rem',
// //           marginBottom:   '0.75rem',
// //         }}>
// //           <div style={{
// //             fontFamily:    'Syne, sans-serif',
// //             fontSize:      isMobile
// //               ? 'clamp(1rem, 8vw, 1.2rem)'
// //               : 'clamp(1rem, 4vw, 1.2rem)',
// //             fontWeight:    800,
// //             letterSpacing: '-0.05em',
// //             lineHeight:    0.9,
// //             textAlign:     'center',
// //             color:         'var(--white)',
// //           }}>
// //             Kind <span style={{ color: 'var(--acid)' }}>Words</span>
// //           </div>
// //         </div>
// //         <p style={{
// //           textAlign:  'center',
// //           color:      'var(--muted)',
// //           maxWidth:   '700px',
// //           margin:     '0 auto',
// //           lineHeight: '1.6',
// //         }}>
// //           Feedback from founders, clients, and teams.
// //         </p>
// //       </div>

// //       {/* ── Main: image right + cards left ──────────────────────── */}
// //       <div style={{
// //         flex:     1,
// //         position: 'relative',
// //         overflow: 'hidden',
// //       }}>

// //         {/* Image — slides in from right (desktop only) */}
// //         {!isMobile && (
// //           <div
// //             ref={imgWrapRef}
// //             style={{
// //               position:   'absolute',
// //               right:       0,
// //               top:         0,
// //               bottom:      0,
// //               width:       '52%',
// //               zIndex:      5,
// //               overflow:    'hidden',
// //               willChange:  'transform',
// //             }}
// //           >
// //             <img
// //               src={imageSrc}
// //               alt="outro visual"
// //               style={{
// //                 width:          '100%',
// //                 height:         '100%',
// //                 objectFit:      'contain',
// //                 objectPosition: 'center',
// //                 display:        'block',
// //               }}
// //               onError={e => { e.currentTarget.style.opacity = '0'; }}
// //             />
// //             {/* Gradient fade — blends left edge of image into black */}
// //             <div style={{
// //               position:      'absolute',
// //               inset:          0,
// //               pointerEvents: 'none',
// //               zIndex:         2,
// //             }} />
// //           </div>
// //         )}

// //         {/* Card stack — flies in from left */}
// //         <div style={{
// //           position:       'absolute',
// //           left:           0,
// //           top:            0,
// //           bottom:         0,
// //           width:          isMobile ? '100%' : '58%',
// //           display:        'flex',
// //           alignItems:     'center',
// //           justifyContent: 'center',
// //           zIndex:         10,
// //         }}>
// //           {ITEMS.map((review, i) => (
// //             <ReviewCard
// //               key={review.id || i}
// //               review={review}
// //               ref={el => cardRefs.current[i] = el}
// //               isMobile={isMobile}
// //             />
// //           ))}
// //         </div>

// //       </div>
// //     </div>
// //   );
// // }

// // // ─── CertImage ───────────────────────────────────────────────────
// // function CertImage({ src, alt, color, title, issuer }) {
// //   const imgRef  = useRef(null);
// //   const fallRef = useRef(null);
// //   const initials = (title || '').split(' ').slice(0, 2).map(w => w[0]).join('');

// //   return (
// //     <div style={{ position: 'relative', width: '100%', height: '100%' }}>
// //       <img
// //         ref={imgRef}
// //         src={src}
// //         alt={alt}
// //         loading="eager"
// //         decoding="async"
// //         fetchPriority="high"
// //         onError={() => {
// //           if (imgRef.current)  imgRef.current.style.display  = 'none';
// //           if (fallRef.current) fallRef.current.style.display = 'flex';
// //         }}
// //         style={{
// //           width: '100%', height: '100%',
// //           objectFit: 'contain', objectPosition: 'center',
// //           display: 'block',
// //         }}
// //       />
// //       <div ref={fallRef} style={{
// //         display: 'none', position: 'absolute', inset: 0,
// //         flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
// //         gap: '0.75rem',
// //       }}>
// //         <span style={{
// //           fontFamily: 'Syne, sans-serif', fontWeight: 800,
// //           fontSize: '3rem', color: 'var(--white)', opacity: 0.15,
// //         }}>{initials}</span>
// //         <div style={{
// //           fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: '0.85rem',
// //           color: 'var(--white)', textAlign: 'center',
// //           padding: '0 2rem', lineHeight: 1.25, opacity: 0.4,
// //         }}>{title}</div>
// //         <div style={{
// //           fontFamily: 'Space Mono, monospace', fontSize: '0.55rem',
// //           color: 'var(--muted)', letterSpacing: '0.18em', textTransform: 'uppercase',
// //         }}>{issuer}</div>
// //       </div>
// //     </div>
// //   );
// // }

// // // ─── ProgressRail ─────────────────────────────────────────────────
// // function ProgressRail({ count, activeIndex, isMobile }) {
// //   return (
// //     <div style={{
// //       position: 'absolute',
// //       zIndex: 30,
// //       left: '5vw', right: '5vw',
// //       display: 'flex', gap: '6px', alignItems: 'center',
// //       pointerEvents: 'none',
// //       ...(isMobile
// //         ? { top: `${HEADER_H + IMAGE_ZONE_H - 1}px`, bottom: 'auto' }
// //         : { bottom: `${TICKER_H + 12}px`,            top:    'auto' }
// //       ),
// //     }}>
// //       {Array.from({ length: count }).map((_, i) => (
// //         <div key={i} style={{
// //           flex: i === activeIndex ? 4 : 1,
// //           height: '1px',
// //           background: i === activeIndex ? 'var(--acid)' : '#222',
// //           transition: 'flex 0.45s cubic-bezier(0.4,0,0.2,1), background 0.3s',
// //         }} />
// //       ))}
// //     </div>
// //   );
// // }

// // // ─── CertContent ─────────────────────────────────────────────────
// // function CertContent({ cert, index, total, isMobile }) {
// //   const level = LEVEL_MAP[cert.level] || LEVEL_MAP['Associate'];
// //   const description = cert.desc || cert.description || '';
// //   const skillTags = cert.tags || cert.skills || [];

// //   return (
// //     <div style={{
// //       position: 'relative',
// //       width: '100%', height: '100%',
// //       display: 'flex', flexDirection: 'column', justifyContent: 'center',
// //       padding: isMobile ? '1.2rem 6vw 1.2rem 8vw' : '2rem 5vw 2rem 5vw',
// //       boxSizing: 'border-box',
// //       overflow: 'hidden',
// //     }}>
// //       <div aria-hidden="true" style={{
// //         position: 'absolute',
// //         top: '50%', right: '-0.04em',
// //         transform: 'translateY(-50%)',
// //         fontFamily: 'Syne, sans-serif',
// //         fontSize: isMobile ? 'clamp(26vw,33vw,40vw)' : 'clamp(16vw,20vw,26vw)',
// //         fontWeight: 800,
// //         color: cert.color,
// //         opacity: 0.05,
// //         lineHeight: 1,
// //         userSelect: 'none', pointerEvents: 'none',
// //         letterSpacing: '-0.06em',
// //         zIndex: 0,
// //       }}>{pad(index + 1)}</div>

// //       <div style={{
// //         position: 'absolute',
// //         left: isMobile ? '4vw' : '2vw',
// //         top: '10%', bottom: '10%',
// //         width: '1px',
// //         background: `linear-gradient(to bottom, transparent, ${cert.color}88, transparent)`,
// //         zIndex: 1,
// //       }} />

// //       <div style={{ position: 'relative', zIndex: 2 }}>
// //         <div style={{
// //           display: 'flex', alignItems: 'center',
// //           gap: '0.75rem',
// //           marginBottom: isMobile ? '0.7rem' : '1.4rem',
// //           flexWrap: 'wrap',
// //         }}>
// //           <span style={{
// //             fontFamily: 'Space Mono, monospace',
// //             fontSize: isMobile ? '0.65rem' : '0.75rem',
// //             color: cert.color, letterSpacing: '0.2em', fontWeight: 700,
// //           }}>
// //             {pad(index + 1)} / {pad(total)}
// //           </span>
// //           <div style={{ width: 20, height: '1px', background: `${cert.color}55` }} />
// //           <span style={{
// //             fontFamily: 'Space Mono, monospace',
// //             fontSize: '0.6rem', color: 'var(--muted)', letterSpacing: '0.12em',
// //           }}>
// //             {cert.issuer?.toUpperCase()}
// //           </span>
// //           {cert.year && (
// //             <span style={{
// //               fontFamily: 'Space Mono, monospace',
// //               fontSize: '0.6rem', color: 'var(--muted)',
// //               letterSpacing: '0.1em', marginLeft: 'auto',
// //             }}>
// //               {cert.year}
// //             </span>
// //           )}
// //         </div>

// //         <h2 style={{
// //           fontFamily: 'Syne, sans-serif', fontWeight: 800,
// //           fontSize: isMobile
// //             ? 'clamp(1.25rem, 5.5vw, 2rem)'
// //             : 'clamp(2rem, 4vw, 4.5rem)',
// //           letterSpacing: '-0.04em', lineHeight: 1,
// //           color: 'var(--white)',
// //           margin: isMobile ? '0 0 0.7rem' : '0 0 1.2rem',
// //         }}>
// //           {cert.title}
// //         </h2>

// //         <div style={{
// //           width: isMobile ? 'min(160px, 50vw)' : 'min(280px, 26vw)',
// //           height: '1px',
// //           background: `linear-gradient(90deg, ${cert.color} 0%, transparent 100%)`,
// //           marginBottom: isMobile ? '0.7rem' : '1.2rem',
// //         }} />

// //         {cert.level && (
// //           <div style={{
// //             display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
// //             background: level.bg, border: `1px solid ${level.border}`,
// //             borderRadius: 4, padding: '0.25rem 0.65rem',
// //             marginBottom: isMobile ? '0.7rem' : '1.3rem',
// //           }}>
// //             <span style={{
// //               width: 5, height: 5, borderRadius: '50%',
// //               background: level.text, display: 'inline-block', flexShrink: 0,
// //             }} />
// //             <span style={{
// //               fontFamily: 'Space Mono, monospace', fontSize: '0.58rem',
// //               letterSpacing: '0.12em', color: level.text,
// //               textTransform: 'uppercase', fontWeight: 700,
// //             }}>
// //               {cert.level}
// //             </span>
// //           </div>
// //         )}

// //         {description && !isMobile && (
// //           <p style={{
// //             fontFamily: 'Space Mono, monospace', fontSize: '0.65rem',
// //             color: 'var(--white)', lineHeight: 1.7,
// //             margin: '0 0 1.2rem', maxWidth: '36ch',
// //           }}>
// //             {description}
// //           </p>
// //         )}

// //         {skillTags.length > 0 && (
// //           <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.35rem' }}>
// //             {(isMobile ? skillTags.slice(0, 4) : skillTags).map((sk, si) => (
// //               <span key={si} style={{
// //                 fontFamily: 'Space Mono, monospace',
// //                 fontSize: isMobile ? '0.52rem' : '0.58rem',
// //                 padding: isMobile ? '0.2rem 0.5rem' : '0.25rem 0.7rem',
// //                 background: `${cert.color}0a`, color: '#aaa',
// //                 border: `1px solid ${cert.color}22`,
// //                 borderRadius: 2, letterSpacing: '0.05em',
// //               }}>
// //                 {sk}
// //               </span>
// //             ))}
// //           </div>
// //         )}
// //       </div>

// //       <div style={{
// //         position: 'absolute',
// //         bottom: isMobile ? '0.8rem' : '2rem', right: '5vw',
// //         width: 20, height: 20,
// //         borderRight: '1px solid rgba(200,240,74,0.27)',
// //         borderBottom: '1px solid rgba(200,240,74,0.27)',
// //         zIndex: 2,
// //       }} />
// //     </div>
// //   );
// // }

// // // ─── Main ─────────────────────────────────────────────────────────
// // export default function Certificates({ loaded, isMobile }) {
// //   const [certs,       setCerts]       = useState(null);
// //   const [reviews,     setReviews]     = useState(null);
// //   const [outroImage,  setOutroImage]  = useState(null); // image src from Firestore settings
// //   const [ready,       setReady]       = useState(false);
// //   const [activeIndex, setActiveIndex] = useState(0);

// //   const [outroReveal,    setOutroReveal]    = useState(0);
// //   const [outroImageProg, setOutroImageProg] = useState(0); // 0→1 drives image slide
// //   const [outroCards,     setOutroCards]     = useState(0); // 0→1 drives card fly-in

// //   const sectionRef  = useRef(null);
// //   const imgPanelRef = useRef(null);
// //   const txtPanelRef = useRef(null);
// //   const ctxRef      = useRef(null);

// //   // ── Fetch certs + reviews + settings in parallel ───────────────
// //   useEffect(() => {
// //     fetchCertificates()
// //       .then(data => {
// //         if (data?.length) {
// //           preloadCertImages(data);
// //           setCerts(data);
// //         }
// //       })
// //       .catch(console.error);

// //     fetchReviews()
// //       .then(data => {
// //         if (data?.length) setReviews(data);
// //       })
// //       .catch(console.error);

// //     // Fetch outro image from settings/certificates Firestore doc
// //     // fetchSettings is expected to return an object like { outroImageSrc: '...' }
// //     // If you don't have fetchSettings yet, just hardcode setOutroImage('your-url') here.
// //     if (typeof fetchSettings === 'function') {
// //       fetchSettings('certificates')
// //         .then(data => {
// //           if (data?.outroImageSrc) setOutroImage(data.outroImageSrc);
// //         })
// //         .catch(console.error);
// //     }
// //   }, []);

// //   useEffect(() => {
// //     if (loaded && certs) setReady(true);
// //   }, [loaded, certs]);

// //   // ── GSAP scroll ────────────────────────────────────────────────
// //   useEffect(() => {
// //     if (!ready) return;
// //     const section  = sectionRef.current;
// //     const imgPanel = imgPanelRef.current;
// //     const txtPanel = txtPanelRef.current;
// //     if (!section || !imgPanel || !txtPanel) return;

// //     if (ctxRef.current) { ctxRef.current.revert(); ctxRef.current = null; }

// //     ctxRef.current = gsap.context(() => {
// //       const n = certs.length;

// //       // ── Header reveal ─────────────────────────────────────────
// //       gsap.set('.cv-header-h2',    { clipPath: 'inset(0 100% 0 0 round 4px)', skewX: -6 });
// //       gsap.set('.cv-header-label', { opacity: 0, x: -24 });
// //       gsap.timeline({
// //         scrollTrigger: { trigger: section, start: 'top 85%', once: true },
// //       })
// //         .to('.cv-header-label', { opacity: 1, x: 0, duration: 0.6, ease: 'power3.out' })
// //         .to('.cv-header-h2', {
// //           clipPath: 'inset(0 0% 0 0 round 4px)', skewX: 0,
// //           duration: 1.0, ease: 'expo.inOut',
// //         }, '-=0.3');

// //       const getImgW = () =>
// //         imgPanel.parentElement?.offsetWidth ??
// //         (isMobile ? window.innerWidth : window.innerWidth * 0.5);

// //       const getTxtW = () =>
// //         txtPanel.parentElement?.offsetWidth ??
// //         (isMobile ? window.innerWidth : window.innerWidth * 0.5);

// //       gsap.set(imgPanel, { x: 0 });
// //       gsap.set(txtPanel, { x: 0 });

// //       // ── Cert card strip timelines ─────────────────────────────
// //       const tlImg = gsap.timeline({ paused: true });
// //       tlImg.to(imgPanel, {
// //         x: () => -(n - 1) * getImgW(),
// //         ease: 'none', duration: n - 1,
// //       });

// //       const tlTxt = gsap.timeline({ paused: true });
// //       tlTxt.to(txtPanel, {
// //         x: () => -(n - 1) * getTxtW(),
// //         ease: 'none', duration: n - 1,
// //       });

// //       // ── Outro reveal timeline (clip-path circle expand) ───────
// //       gsap.set('.cv-outro-wrap', {
// //         clipPath: 'circle(0px at 100% 100%)',
// //         opacity:  1,
// //       });

// //       const tlOutro = gsap.timeline({ paused: true });
// //       tlOutro.to('.cv-outro-wrap', {
// //         clipPath: 'circle(150% at 100% 100%)',
// //         ease: 'power2.inOut',
// //         duration: 1,
// //       });

// //       // ── Scroll budget maths ───────────────────────────────────
// //       const getStepH = () => window.innerHeight - HEADER_H;

// //       const getCertEnd = () => {
// //         const certBudget  = (n - 1) * getStepH() + getStepH() * 1.2;
// //         const outroBudget = getStepH() * OUTRO_BUDGET;
// //         return certBudget / (certBudget + outroBudget);
// //       };

// //       ScrollTrigger.create({
// //         trigger: section,
// //         start: 'top top',
// //         end: () => {
// //           const certBudget  = (n - 1) * getStepH() + getStepH() * 1.2;
// //           const outroBudget = getStepH() * OUTRO_BUDGET;
// //           return `+=${certBudget + outroBudget}`;
// //         },
// //         pin: true,
// //         scrub: 3,
// //         anticipatePin: 1,
// //         invalidateOnRefresh: true,

// //         onUpdate(self) {
// //           const p       = self.progress;
// //           const certEnd = getCertEnd();

// //           // ── Cert strip ────────────────────────────────────────
// //           const certP = Math.min(1, p / certEnd);
// //           tlImg.progress(certP);
// //           tlTxt.progress(certP);
// //           const idx = Math.min(n - 1, Math.round(certP * (n - 1)));
// //           setActiveIndex(idx);

// //           // ── Raw outro progress (0→1 across outro budget) ──────
// //           const rawOutroP = certEnd >= 1
// //             ? 0
// //             : Math.max(0, (p - certEnd) / (1 - certEnd));

// //           // ── Phase 1: Circle reveal (rawOutroP 0 → REVEAL_THRESHOLD)
// //           const revealP = Math.min(1, rawOutroP / REVEAL_THRESHOLD);
// //           tlOutro.progress(revealP);
// //           setOutroReveal(revealP);

// //           // ── Phases 2+3 start only after reveal is complete ────
// //           const postRevealP = rawOutroP <= REVEAL_THRESHOLD
// //             ? 0
// //             : (rawOutroP - REVEAL_THRESHOLD) / (1 - REVEAL_THRESHOLD);

// //           // ── Phase 2: Image slides from right (0 → IMAGE_PHASE) ─
// //           const imageP = Math.min(1, postRevealP / IMAGE_PHASE);
// //           setOutroImageProg(imageP);

// //           // ── Phase 3: Cards fly from left (IMAGE_PHASE → 1.0) ──
// //           const cardP = postRevealP <= IMAGE_PHASE
// //             ? 0
// //             : (postRevealP - IMAGE_PHASE) / (1 - IMAGE_PHASE);
// //           setOutroCards(cardP);

// //           // Pointer events: enable once reveal has started
// //           const outroEl = document.querySelector('.cv-outro-wrap');
// //           if (outroEl) {
// //             outroEl.style.pointerEvents = rawOutroP > 0.05 ? 'auto' : 'none';
// //           }
// //         },
// //       });

// //     }, section);

// //     return () => {
// //       if (ctxRef.current) { ctxRef.current.revert(); ctxRef.current = null; }
// //     };
// //   }, [ready, certs, isMobile]);

// //   if (!certs || !ready) return null;

// //   return (
// //     <section
// //       ref={sectionRef}
// //       id="certificates"
// //       style={{
// //         background: 'var(--black)',
// //         position: 'relative',
// //         minHeight: '100vh',
// //         overflow: 'hidden',
// //         touchAction: 'pan-y',
// //       }}
// //     >
// //       {/* ── HEADER STRIP ──────────────────────────────────────────── */}
// //       <div style={{
// //         position: 'absolute',
// //         top: 0, left: 0, right: 0,
// //         height: `${HEADER_H}px`,
// //         zIndex: 20,
// //         display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between',
// //         padding: '0 5vw 1.2rem',
// //         borderBottom: '1px solid #1a1a1a',
// //         boxSizing: 'border-box',
// //         background: 'var(--black)',
// //         pointerEvents: 'none',
// //       }}>
// //         <div>
// //           <div className="cv-header-label" style={{
// //             display: 'flex', alignItems: 'center', gap: '0.6rem',
// //             marginBottom: '1.5rem',
// //           }}>
// //             <span style={{
// //               fontFamily: 'Space Mono, monospace', fontSize: '0.55rem',
// //               color: 'var(--acid)', letterSpacing: '0.2em',
// //             }}>05</span>
// //             <div style={{ width: 24, height: '1px', background: 'var(--acid)', opacity: 0.4 }} />
// //             <span style={{
// //               fontFamily: 'Space Mono, monospace', fontSize: '0.55rem',
// //               color: 'var(--acid)', letterSpacing: '0.18em', textTransform: 'uppercase',
// //             }}>Credentials</span>
// //           </div>
// //           <h2 className="cv-header-h2" style={{
// //             fontFamily: 'Syne, sans-serif', fontWeight: 800,
// //             fontSize: isMobile ? 'clamp(1.4rem,5vw,2rem)' : 'clamp(1.6rem,3vw,3rem)',
// //             letterSpacing: '-0.04em', lineHeight: 0.9,
// //             margin: 0, color: 'var(--white)',
// //           }}>
// //             Earned{' '}<span style={{ color: 'var(--acid)' }}>Badges</span>
// //           </h2>
// //         </div>
// //         <div style={{
// //           fontFamily: 'Space Mono, monospace',
// //           textAlign: 'right', pointerEvents: 'auto',
// //         }}>
// //           <span style={{
// //             fontSize: isMobile ? '1.6rem' : '2.4rem',
// //             fontWeight: 700, color: 'var(--acid)',
// //             display: 'block', lineHeight: 1,
// //           }}>
// //             {pad(activeIndex + 1)}
// //           </span>
// //           <span style={{ fontSize: '0.55rem', color: '#444', letterSpacing: '0.12em' }}>
// //             / {pad(certs.length)} CERTS
// //           </span>
// //         </div>
// //       </div>

// //       {/* ── PROGRESS RAIL ─────────────────────────────────────────── */}
// //       <ProgressRail count={certs.length} activeIndex={activeIndex} isMobile={isMobile} />

// //       {/* ── IMAGE STRIP VIEWPORT ──────────────────────────────────── */}
// //       <div style={{
// //         position: 'absolute',
// //         top:    `${HEADER_H}px`,
// //         left:   0,
// //         width:  isMobile ? '100%' : '50%',
// //         height: isMobile ? `${IMAGE_ZONE_H}px` : undefined,
// //         bottom: isMobile ? undefined : `${TICKER_H}px`,
// //         overflow: 'hidden',
// //         zIndex: 5,
// //       }}>
// //         <div
// //           ref={imgPanelRef}
// //           style={{
// //             display: 'flex', flexDirection: 'row',
// //             width: `${certs.length * 100}%`,
// //             height: '100%',
// //             willChange: 'transform',
// //           }}
// //         >
// //           {certs.map((cert, i) => (
// //             <div
// //               key={cert.id || i}
// //               style={{
// //                 width: `${100 / certs.length}%`,
// //                 flexShrink: 0, height: '100%',
// //                 display: 'flex', alignItems: 'center', justifyContent: 'center',
// //                 padding: isMobile ? '1rem 8vw' : '2rem 3vw 2rem 5vw',
// //                 boxSizing: 'border-box',
// //               }}
// //             >
// //               <div style={{
// //                 width: '100%',
// //                 maxWidth: isMobile ? '80vw' : 500,
// //                 aspectRatio: '4/3',
// //                 overflow: 'hidden',
// //               }}>
// //                 <CertImage
// //                   src={cert.src} alt={cert.title}
// //                   color={cert.color} title={cert.title} issuer={cert.issuer}
// //                 />
// //               </div>
// //             </div>
// //           ))}
// //         </div>
// //       </div>

// //       {/* ── DIVIDER — desktop only ─────────────────────────────────── */}
// //       {!isMobile && (
// //         <div style={{
// //           position: 'absolute',
// //           top: `${HEADER_H}px`, bottom: `${TICKER_H}px`,
// //           left: '50%', width: '1px',
// //           background: 'linear-gradient(to bottom, #141414, #222 20%, #222 80%, #141414)',
// //           zIndex: 8, pointerEvents: 'none',
// //         }} />
// //       )}

// //       {/* ── TEXT STRIP VIEWPORT ───────────────────────────────────── */}
// //       <div style={{
// //         position: 'absolute',
// //         top:    isMobile ? `${HEADER_H + IMAGE_ZONE_H}px` : `${HEADER_H}px`,
// //         left:   isMobile ? 0 : '50%',
// //         width:  isMobile ? '100%' : '50%',
// //         height: isMobile ? MOBILE_TEXT_H : undefined,
// //         bottom: isMobile ? undefined : `${TICKER_H}px`,
// //         overflow: 'hidden',
// //         zIndex: 10,
// //       }}>
// //         <div
// //           ref={txtPanelRef}
// //           style={{
// //             display: 'flex', flexDirection: 'row',
// //             width: `${certs.length * 100}%`,
// //             height: '100%',
// //             willChange: 'transform',
// //           }}
// //         >
// //           {certs.map((cert, i) => (
// //             <div
// //               key={cert.id || i}
// //               style={{
// //                 width: `${100 / certs.length}%`,
// //                 flexShrink: 0, height: '100%',
// //               }}
// //             >
// //               <CertContent
// //                 cert={cert}
// //                 index={i}
// //                 total={certs.length}
// //                 isMobile={isMobile}
// //               />
// //             </div>
// //           ))}
// //         </div>
// //       </div>

// //       {/* ── TICKER STRIP ──────────────────────────────────────────── */}
// //       <div style={{
// //         position: 'absolute',
// //         bottom: 0, left: 0, right: 0,
// //         height: `${TICKER_H}px`,
// //         overflow: 'hidden',
// //         borderTop: '1px solid #111',
// //         display: 'flex', alignItems: 'center',
// //         background: 'var(--black)', zIndex: 25,
// //       }}>
// //         <div style={{
// //           display: 'flex', gap: '2rem', whiteSpace: 'nowrap',
// //           animation: 'cv-ticker 30s linear infinite',
// //         }}>
// //           {[...certs, ...certs, ...certs, ...certs].map((c, i) => (
// //             <span key={i} style={{
// //               fontFamily: 'Syne, sans-serif', fontWeight: 700,
// //               fontSize: '0.7rem', letterSpacing: '-0.01em',
// //               color: i % 2 === 0 ? 'var(--white)' : `${c.color}`,
// //             }}>
// //               {c.title}
// //               <span style={{ opacity: 0.15, marginLeft: '0.5rem' }}>·</span>
// //             </span>
// //           ))}
// //         </div>
// //       </div>

// //       {/* ── OUTRO REVEAL ──────────────────────────────────────────── */}
// //       <div
// //         className="cv-outro-wrap"
// //         style={{
// //           position:      'absolute',
// //           top: 0, left: 0,
// //           width:         '100%',
// //           height:        '100%',
// //           zIndex:        40,
// //           overflow:      'hidden',
// //           background:    'var(--black)',
// //           pointerEvents: 'none',
// //         }}
// //       >
// // <OutroReviews
// //   imageProgress={outroImageProg}
// //   cardProgress={outroCards}
// //   isMobile={isMobile}
// //   reviews={reviews}
// //   imageSrc="./side1.png"
// // />
// //       </div>

// //       <style>{`
// //         @keyframes cv-ticker {
// //           from { transform: translateX(0); }
// //           to   { transform: translateX(-50%); }
// //         }
// //       `}</style>
// //     </section>
// //   );
// // }





import { useEffect, useRef, useState, forwardRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { fetchCertificates, fetchReviews, REST_BASE, API_KEY } from './data';

gsap.registerPlugin(ScrollTrigger);

const pad = n => String(n).padStart(2, '0');

// ─── Constants ────────────────────────────────────────────────────
const HEADER_H     = 120;
const TICKER_H     = 36;
const IMAGE_ZONE_H = 260;

const MOBILE_TEXT_H = `calc(100vh - ${HEADER_H}px - ${IMAGE_ZONE_H}px - ${TICKER_H}px)`;
const OUTRO_BUDGET  = 3.5;

// Circle reveal completes at this fraction before image/cards start
const REVEAL_THRESHOLD = 0.35;

// Within postReveal progress: image occupies first IMAGE_PHASE, then cards
const IMAGE_PHASE = 0.45;

// ─── Firestore REST helpers ───────────────────────────────────────
function fromValue(v) {
  if (!v) return null;
  if ('stringValue'  in v) return v.stringValue;
  if ('integerValue' in v) return Number(v.integerValue);
  if ('doubleValue'  in v) return Number(v.doubleValue);
  if ('booleanValue' in v) return v.booleanValue;
  if ('nullValue'    in v) return null;
  if ('arrayValue'   in v) return (v.arrayValue.values || []).map(fromValue);
  if ('mapValue'     in v) {
    const o = {};
    for (const [k, val] of Object.entries(v.mapValue.fields || {})) o[k] = fromValue(val);
    return o;
  }
  return null;
}
function fromFields(fields) {
  const o = {};
  for (const [k, v] of Object.entries(fields)) o[k] = fromValue(v);
  return o;
}

// ─── Level colour map ─────────────────────────────────────────────
const LEVEL_MAP = {
  Expert:       { bg: 'rgba(83,74,183,0.15)',  border: '#534AB7', text: '#AFA9EC' },
  Professional: { bg: 'rgba(15,110,86,0.15)',  border: '#0F6E56', text: '#5DCAA5' },
  Associate:    { bg: 'rgba(133,79,11,0.15)',  border: '#854F0B', text: '#EF9F27' },
};

// ─── Preload cert images ──────────────────────────────────────────
function preloadCertImages(certs) {
  certs.forEach(cert => {
    if (!cert.src) return;
    const img = new Image();
    img.fetchPriority = 'auto';
    img.src = cert.src;
  });
}

// ─── Fallback reviews ────────────────────────────────────────────
const FALLBACK_REVIEWS = [
  {
    id: '01',
    name: 'Arju',
    role: 'Founder, Orbit Labs',
    text: 'Naveen has a rare instinct for turning vague briefs into something that feels inevitable. Every animation, every hover state — nothing felt like a default.',
    tag: 'UI/UX',
    year: '2024',
  },
  {
    id: '02',
    name: 'Sarah Lindström',
    role: 'Creative Director, Helix Studio',
    text: 'The portfolio site he built us stopped people mid-scroll. We got three new client inquiries the week it launched, all citing the site directly.',
    tag: 'Frontend Dev',
    year: '2024',
  },
  {
    id: '03',
    name: 'Kabir Nair',
    role: 'CTO, Stackfield',
    text: 'Technically sharp and visually fluent — an unusual combination. He rebuilt our admin panel from the ground up and the performance gains were immediate.',
    tag: 'Full Stack',
    year: '2023',
  },
  {
    id: '04',
    name: 'Priya Rajan',
    role: 'Head of Product, Nomad OS',
    text: 'What stood out was the attention to micro-interactions. Every transition felt earned. He pushed back on two of my ideas and was right both times.',
    tag: 'Product Design',
    year: '2023',
  },
  {
    id: '05',
    name: 'Tom Breckenridge',
    role: 'Lead Engineer, Vanta Systems',
    text: 'Clean, maintainable React. The GSAP work was surgical — no bloat, no jank. Rare to find someone who cares about the code as much as the output.',
    tag: 'React / GSAP',
    year: '2023',
  },
];

const TILTS   = [-4, 2.5, -1.5, 3, -2, -3.5, 1.8, -2.2, 3.5, -1];
const OFFSETS = [0, -6, 4, -3, 5, -4, 3, -5, 2, -2];

// ─── Easing ───────────────────────────────────────────────────────
function easeOutBack(t) {
  const c1 = 1.70158;
  const c3 = c1 + 1;
  return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2);
}

// ─── ReviewCard ───────────────────────────────────────────────────
const ReviewCard = forwardRef(function ReviewCard({ review, isMobile }, ref) {
  const cardW = isMobile ? 'min(82vw, 340px)' : '40vw';

  return (
    <div
      ref={ref}
      style={{
        position:     'absolute',
        width:        cardW,
        background:   'var(--black)',
        border:       '1px solid var(--border)',
        borderRadius: '6px',
        padding:      isMobile ? '1.4rem 1.2rem' : '2.2rem 2rem',
        boxSizing:    'border-box',
        willChange:   'transform',
      }}
    >
      {/* Tag */}
      <div style={{
        display:        'flex',
        justifyContent: 'space-between',
        alignItems:     'center',
        marginBottom:   isMobile ? '1rem' : '1.6rem',
      }}>
        <span style={{
          fontFamily:    'Space Mono, monospace',
          fontSize:      '0.6rem',
          color:         'var(--acid)',
          letterSpacing: '0.18em',
          textTransform: 'uppercase',
          border:        '1px solid var(--border)',
          borderRadius:  '2px',
          padding:       '0.2rem 0.5rem',
        }}>
          {review.tag}
        </span>
      </div>

      {/* Quote mark */}
      <div style={{
        fontFamily:   'Syne, sans-serif',
        fontSize:     isMobile ? '2.4rem' : '3.5rem',
        lineHeight:   0.7,
        color:        'var(--white)',
        marginBottom: isMobile ? '0.6rem' : '0.8rem',
        userSelect:   'none',
      }}>
        "
      </div>

      {/* Review text */}
      <p style={{
        fontFamily:   'Space Mono, monospace',
        fontSize:     isMobile
          ? 'clamp(0.5rem, 2.2vw, 0.65rem)'
          : 'clamp(0.6rem, 1vw, 0.78rem)',
        lineHeight:   1.8,
        color:        'var(--white)',
        opacity:      0.75,
        margin:       0,
        marginBottom: isMobile ? '1.2rem' : '2rem',
      }}>
        {review.text}
      </p>

      {/* Divider */}
      <div style={{
        height:       '1px',
        background:   'var(--border)',
        marginBottom: isMobile ? '0.8rem' : '1.2rem',
      }} />

      {/* Reviewer info */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
        <div>
          <div style={{
            fontFamily:    'Syne, sans-serif',
            fontSize:      isMobile ? '0.6rem' : '0.75rem',
            fontWeight:    700,
            color:         'var(--white)',
            letterSpacing: '-0.02em',
            marginBottom:  '0.15rem',
          }}>
            {review.name}
          </div>
          <div style={{
            fontFamily:    'Space Mono, monospace',
            fontSize:      '0.6rem',
            color:         'var(--dummy)',
            letterSpacing: '0.06em',
          }}>
            {review.role}
          </div>
        </div>
        <span style={{
          fontFamily:    'Space Mono, monospace',
          fontSize:      '0.6rem',
          color:         'var(--dummy)',
          letterSpacing: '0.1em',
        }}>
          {review.year}
        </span>
      </div>
    </div>
  );
});

// ─── OutroReviews ─────────────────────────────────────────────────
// imageProgress  0→1 — drives the maskImage sliding in from right
// cardProgress   0→1 — drives review cards flying in from left
// maskImage      — the base image URL from Firestore settings/certificates
function OutroReviews({ imageProgress, cardProgress, isMobile, reviews: reviewsProp, maskImage }) {
  const cardRefs   = useRef([]);
  const imgWrapRef = useRef(null);
  const progressRef = useRef({ img: 0, card: 0 });
  const rafRef     = useRef(null);

  const ITEMS = (reviewsProp && reviewsProp.length > 0) ? reviewsProp : FALLBACK_REVIEWS;
  const total = ITEMS.length;

  // Keep live ref for rAF
  useEffect(() => {
    progressRef.current = { img: imageProgress, card: cardProgress };
  }, [imageProgress, cardProgress]);

  // One-time: set initial off-screen positions
  useEffect(() => {
    // Cards start off-screen LEFT
    cardRefs.current.forEach((card, i) => {
      if (!card) return;
      gsap.set(card, {
        x:        '-120vw',
        y:        OFFSETS[i] ?? 0,
        rotation: TILTS[i]  ?? 0,
        zIndex:   i,
        opacity:  1,
      });
    });
    // Image starts off-screen RIGHT
    if (imgWrapRef.current) {
      gsap.set(imgWrapRef.current, { x: '110vw' });
    }
  }, [ITEMS.length]);

  // rAF loop driving both image and cards
  useEffect(() => {
    function tick() {
      const { img: imgP, card: cardP } = progressRef.current;

      // Image slides in from right
      if (imgWrapRef.current) {
        const eImg = easeOutBack(Math.min(1, imgP));
        gsap.set(imgWrapRef.current, {
          x: window.innerWidth * 1.1 * (1 - eImg),
        });
      }

      // Cards fly in from left, staggered
      cardRefs.current.forEach((card, i) => {
        if (!card) return;
        const landStart = i / total;
        const landP     = Math.max(0, Math.min(1, (cardP - landStart) / (1 / total)));
        const eL        = easeOutBack(landP);
        gsap.set(card, {
          x:        -window.innerWidth * 1.2 * (1 - eL),
          y:        OFFSETS[i] ?? 0,
          rotation: TILTS[i]  ?? 0,
          zIndex:   i,
        });
      });

      rafRef.current = requestAnimationFrame(tick);
    }
    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
  }, [total]);

  return (
    <div style={{
      width:         '100%',
      height:        '100%',
      background:    'var(--black)',
      display:       'flex',
      flexDirection: 'column',
      overflow:      'hidden',
      position:      'relative',
      
    }}
    data-cursor-text="Scroll Down"
    >

      {/* ── Header ──────────────────────────────────────────────── */}
      <div style={{
        padding:    '2rem 5vw 1.5rem',
        flexShrink: 0,
        position:   'relative',
        zIndex:     20,
      }}>
        <div style={{
          display:        'flex',
          alignItems:     isMobile ? 'flex-start' : 'baseline',
          flexDirection:  isMobile ? 'row' : 'row',
          justifyContent: 'center',
          gap:            isMobile ? '0.4rem' : '1rem',
          marginBottom:   '0.75rem',
        }}>
          <div style={{
            fontFamily:    'Syne, sans-serif',
            fontSize:      isMobile
              ? 'clamp(1rem, 8vw, 1.2rem)'
              : 'clamp(1rem, 4vw, 1.2rem)',
            fontWeight:    800,
            letterSpacing: '-0.05em',
            lineHeight:    0.9,
            textAlign:     'center',
            color:         'var(--white)',
          }}>
            Kind <span style={{ color: 'var(--acid)' }}>Words</span>
          </div>
        </div>
        <p style={{
          textAlign:  'center',
          color:      'var(--muted)',
          maxWidth:   '700px',
          margin:     '0 auto',
          lineHeight: '1.6',
        }}>
          Feedback from founders, clients, and teams.
        </p>
      </div>

      {/* ── Main area: image right + cards left ─────────────────── */}
      <div style={{
        flex:     1,
        position: 'relative',
        overflow: 'hidden',
      }}>

        {/* ── maskImage — slides in from right (desktop only) ───── */}
        {!isMobile && maskImage && (
          <div
            ref={imgWrapRef}
            style={{
              position:  'absolute',
              right:      0,
              top:        0,
              bottom:     0,
              width:      '52%',
              zIndex:     5,
              overflow:   'hidden',
              willChange: 'transform',
            }}
          >
            {/* key forces remount if URL changes, same pattern as old OutroHero */}
            <img
              key={maskImage}
              src={maskImage}
              alt="outro visual"
              style={{
                width:          '100%',
                height:         '100%',
                objectFit:      'contain',
                objectPosition: 'center',
                display:        'block',
              }}
              onError={e => { e.currentTarget.style.opacity = '0'; }}
            />
            {/* Gradient fades left edge of image into black */}
            <div style={{
              position:      'absolute',
              inset:          0,
              pointerEvents: 'none',
              zIndex:         2,
            }} />
          </div>
        )}

        {/* ── Card stack — flies in from left ─────────────────── */}
        <div style={{
          position:       'absolute',
          left:           0,
          top:            0,
          bottom:         0,
          width:          isMobile ? '100%' : '58%',
          display:        'flex',
          alignItems:     'center',
          justifyContent: 'center',
          zIndex:         10,
        }}>
          {ITEMS.map((review, i) => (
            <ReviewCard
              key={review.id || i}
              review={review}
              ref={el => cardRefs.current[i] = el}
              isMobile={isMobile}
            />
          ))}
        </div>

      </div>
    </div>
  );
}

// ─── CertImage ───────────────────────────────────────────────────
function CertImage({ src, alt, color, title, issuer }) {
  const imgRef  = useRef(null);
  const fallRef = useRef(null);
  const initials = (title || '').split(' ').slice(0, 2).map(w => w[0]).join('');

  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <img
        ref={imgRef}
        src={src}
        alt={alt}
        loading="eager"
        decoding="async"
        fetchPriority="high"
        onError={() => {
          if (imgRef.current)  imgRef.current.style.display  = 'none';
          if (fallRef.current) fallRef.current.style.display = 'flex';
        }}
        style={{
          width: '100%', height: '100%',
          objectFit: 'contain', objectPosition: 'center',
          display: 'block',
        }}
      />
      <div ref={fallRef} style={{
        display: 'none', position: 'absolute', inset: 0,
        flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        gap: '0.75rem',
      }}>
        <span style={{
          fontFamily: 'Syne, sans-serif', fontWeight: 800,
          fontSize: '3rem', color: 'var(--white)', opacity: 0.15,
        }}>{initials}</span>
        <div style={{
          fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: '0.85rem',
          color: 'var(--white)', textAlign: 'center',
          padding: '0 2rem', lineHeight: 1.25, opacity: 0.4,
        }}>{title}</div>
        <div style={{
          fontFamily: 'Space Mono, monospace', fontSize: '0.55rem',
          color: 'var(--muted)', letterSpacing: '0.18em', textTransform: 'uppercase',
        }}>{issuer}</div>
      </div>
    </div>
  );
}

// ─── ProgressRail ─────────────────────────────────────────────────
function ProgressRail({ count, activeIndex, isMobile }) {
  return (
    <div style={{
      position: 'absolute',
      zIndex: 30,
      left: '5vw', right: '5vw',
      display: 'flex', gap: '6px', alignItems: 'center',
      pointerEvents: 'none',
      ...(isMobile
        ? { top: `${HEADER_H + IMAGE_ZONE_H - 1}px`, bottom: 'auto' }
        : { bottom: `${TICKER_H + 12}px`,            top:    'auto' }
      ),
    }}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} style={{
          flex: i === activeIndex ? 4 : 1,
          height: '1px',
          background: i === activeIndex ? 'var(--acid)' : '#222',
          transition: 'flex 0.45s cubic-bezier(0.4,0,0.2,1), background 0.3s',
        }} />
      ))}
    </div>
  );
}

// ─── CertContent ─────────────────────────────────────────────────
function CertContent({ cert, index, total, isMobile }) {
  const level = LEVEL_MAP[cert.level] || LEVEL_MAP['Associate'];
  const description = cert.desc || cert.description || '';
  const skillTags = cert.tags || cert.skills || [];

  return (
    <div style={{
      position: 'relative',
      width: '100%', height: '100%',
      display: 'flex', flexDirection: 'column', justifyContent: 'center',
      padding: isMobile ? '1.2rem 6vw 1.2rem 8vw' : '2rem 5vw 2rem 5vw',
      boxSizing: 'border-box',
      overflow: 'hidden',
    }}>
      <div aria-hidden="true" style={{
        position: 'absolute',
        top: '50%', right: '-0.04em',
        transform: 'translateY(-50%)',
        fontFamily: 'Syne, sans-serif',
        fontSize: isMobile ? 'clamp(26vw,33vw,40vw)' : 'clamp(16vw,20vw,26vw)',
        fontWeight: 800,
        color: cert.color,
        opacity: 0.05,
        lineHeight: 1,
        userSelect: 'none', pointerEvents: 'none',
        letterSpacing: '-0.06em',
        zIndex: 0,
      }}>{pad(index + 1)}</div>

      <div style={{
        position: 'absolute',
        left: isMobile ? '4vw' : '2vw',
        top: '10%', bottom: '10%',
        width: '1px',
        background: `linear-gradient(to bottom, transparent, ${cert.color}88, transparent)`,
        zIndex: 1,
      }} />

      <div style={{ position: 'relative', zIndex: 2 }}>
        <div style={{
          display: 'flex', alignItems: 'center',
          gap: '0.75rem',
          marginBottom: isMobile ? '0.7rem' : '1.4rem',
          flexWrap: 'wrap',
        }}>
          <span style={{
            fontFamily: 'Space Mono, monospace',
            fontSize: isMobile ? '0.65rem' : '0.75rem',
            color: cert.color, letterSpacing: '0.2em', fontWeight: 700,
          }}>
            {pad(index + 1)} / {pad(total)}
          </span>
          <div style={{ width: 20, height: '1px', background: `${cert.color}55` }} />
          <span style={{
            fontFamily: 'Space Mono, monospace',
            fontSize: '0.6rem', color: 'var(--muted)', letterSpacing: '0.12em',
          }}>
            {cert.issuer?.toUpperCase()}
          </span>
          {cert.year && (
            <span style={{
              fontFamily: 'Space Mono, monospace',
              fontSize: '0.6rem', color: 'var(--muted)',
              letterSpacing: '0.1em', marginLeft: 'auto',
            }}>
              {cert.year}
            </span>
          )}
        </div>

        <h2 style={{
          fontFamily: 'Syne, sans-serif', fontWeight: 800,
          fontSize: isMobile
            ? 'clamp(1.25rem, 5.5vw, 2rem)'
            : 'clamp(2rem, 4vw, 4.5rem)',
          letterSpacing: '-0.04em', lineHeight: 1,
          color: 'var(--white)',
          margin: isMobile ? '0 0 0.7rem' : '0 0 1.2rem',
        }}>
          {cert.title}
        </h2>

        <div style={{
          width: isMobile ? 'min(160px, 50vw)' : 'min(280px, 26vw)',
          height: '1px',
          background: `linear-gradient(90deg, ${cert.color} 0%, transparent 100%)`,
          marginBottom: isMobile ? '0.7rem' : '1.2rem',
        }} />

        {cert.level && (
          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
            background: level.bg, border: `1px solid ${level.border}`,
            borderRadius: 4, padding: '0.25rem 0.65rem',
            marginBottom: isMobile ? '0.7rem' : '1.3rem',
          }}>
            <span style={{
              width: 5, height: 5, borderRadius: '50%',
              background: level.text, display: 'inline-block', flexShrink: 0,
            }} />
            <span style={{
              fontFamily: 'Space Mono, monospace', fontSize: '0.58rem',
              letterSpacing: '0.12em', color: level.text,
              textTransform: 'uppercase', fontWeight: 700,
            }}>
              {cert.level}
            </span>
          </div>
        )}

        {description && !isMobile && (
          <p style={{
            fontFamily: 'Space Mono, monospace', fontSize: '0.65rem',
            color: 'var(--white)', lineHeight: 1.7,
            margin: '0 0 1.2rem', maxWidth: '36ch',
          }}>
            {description}
          </p>
        )}

        {skillTags.length > 0 && (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.35rem' }}>
            {(isMobile ? skillTags.slice(0, 4) : skillTags).map((sk, si) => (
              <span key={si} style={{
                fontFamily: 'Space Mono, monospace',
                fontSize: isMobile ? '0.52rem' : '0.58rem',
                padding: isMobile ? '0.2rem 0.5rem' : '0.25rem 0.7rem',
                background: `${cert.color}0a`, color: '#aaa',
                border: `1px solid ${cert.color}22`,
                borderRadius: 2, letterSpacing: '0.05em',
              }}>
                {sk}
              </span>
            ))}
          </div>
        )}
      </div>

      <div style={{
        position: 'absolute',
        bottom: isMobile ? '0.8rem' : '2rem', right: '5vw',
        width: 20, height: 20,
        borderRight: '1px solid rgba(200,240,74,0.27)',
        borderBottom: '1px solid rgba(200,240,74,0.27)',
        zIndex: 2,
      }} />
    </div>
  );
}

// ─── Main ─────────────────────────────────────────────────────────
export default function Certificates({ loaded, isMobile }) {
  const [certs,       setCerts]       = useState(null);
  const [reviews,     setReviews]     = useState(null);
  const [ready,       setReady]       = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  // Outro image — maskImage from settings/certificates in Firestore
  const [outroMaskImage, setOutroMaskImage] = useState('./mask.png');

  // Three scroll-driven progress values:
  // outroReveal    — drives the circle clip-path (0→1)
  // outroImageProg — drives maskImage sliding in from right (0→1)
  // outroCards     — drives review cards flying in from left (0→1)
  const [outroReveal,    setOutroReveal]    = useState(0);
  const [outroImageProg, setOutroImageProg] = useState(0);
  const [outroCards,     setOutroCards]     = useState(0);

  const sectionRef  = useRef(null);
  const imgPanelRef = useRef(null);
  const txtPanelRef = useRef(null);
  const ctxRef      = useRef(null);

  // ── Fetch certs + reviews + outro settings in parallel ─────────
  useEffect(() => {
    // Certificates
    fetchCertificates()
      .then(data => {
        if (data?.length) {
          preloadCertImages(data);
          setCerts(data);
        }
      })
      .catch(console.error);

    // Reviews
    fetchReviews()
      .then(data => {
        if (data?.length) setReviews(data);
      })
      .catch(console.error);

    // Outro image — same fetch pattern as your old OutroHero code.
    // Reads `maskImage` field from settings/certificates Firestore doc.
    // cache: 'no-store' prevents stale URLs (same fix as your old code).
    async function loadOutroSettings() {
      try {
        const res = await fetch(
          `${REST_BASE}/settings/certificates?key=${API_KEY}`,
          { cache: 'no-store' }
        );
        if (!res.ok) return;
        const json = await res.json();
        if (!json.fields) return;
        const s = fromFields(json.fields);
        if (s.maskImage) setOutroMaskImage(s.maskImage);
      } catch (err) {
        console.warn('fetchOutroSettings failed:', err);
      }
    }
    loadOutroSettings();
  }, []);

  useEffect(() => {
    if (loaded && certs) setReady(true);
  }, [loaded, certs]);

  // ── GSAP scroll ────────────────────────────────────────────────
  useEffect(() => {
    if (!ready) return;
    const section  = sectionRef.current;
    const imgPanel = imgPanelRef.current;
    const txtPanel = txtPanelRef.current;
    if (!section || !imgPanel || !txtPanel) return;

    if (ctxRef.current) { ctxRef.current.revert(); ctxRef.current = null; }

    ctxRef.current = gsap.context(() => {
      const n = certs.length;

      // ── Header reveal ─────────────────────────────────────────
      // gsap.set('.cv-header-h2',    { clipPath: 'inset(0 100% 0 0 round 4px)', skewX: -6 });
      // gsap.set('.cv-header-label', { opacity: 0, x: -24 });
      // gsap.timeline({
      //   scrollTrigger: { trigger: section, start: 'top 85%', once: true },
      // })
      //   .to('.cv-header-label', { opacity: 1, x: 0, duration: 0.6, ease: 'power3.out' })
      //   .to('.cv-header-h2', {
      //     clipPath: 'inset(0 0% 0 0 round 4px)', skewX: 0,
      //     duration: 1.0, ease: 'expo.inOut',
      //   }, '-=0.3');

      const getImgW = () =>
        imgPanel.parentElement?.offsetWidth ??
        (isMobile ? window.innerWidth : window.innerWidth * 0.5);

      const getTxtW = () =>
        txtPanel.parentElement?.offsetWidth ??
        (isMobile ? window.innerWidth : window.innerWidth * 0.5);

      gsap.set(imgPanel, { x: 0 });
      gsap.set(txtPanel, { x: 0 });

      // ── Cert strip timelines ──────────────────────────────────
      const tlImg = gsap.timeline({ paused: true });
      tlImg.to(imgPanel, {
        x: () => -(n - 1) * getImgW(),
        ease: 'none', duration: n - 1,
      });

      const tlTxt = gsap.timeline({ paused: true });
      tlTxt.to(txtPanel, {
        x: () => -(n - 1) * getTxtW(),
        ease: 'none', duration: n - 1,
      });

      // ── Outro circle-reveal timeline ──────────────────────────
      gsap.set('.cv-outro-wrap', {
        clipPath: 'circle(0px at 100% 100%)',
        opacity:  1,
      });

      const tlOutro = gsap.timeline({ paused: true });
      tlOutro.to('.cv-outro-wrap', {
        clipPath: 'circle(150% at 100% 100%)',
        ease: 'power2.inOut',
        duration: 1,
      });

      // ── Scroll budget maths ───────────────────────────────────
      const getStepH = () => window.innerHeight - HEADER_H;

      const getCertEnd = () => {
        const certBudget  = (n - 1) * getStepH() + getStepH() * 1.2;
        const outroBudget = getStepH() * OUTRO_BUDGET;
        return certBudget / (certBudget + outroBudget);
      };

      ScrollTrigger.create({
        trigger: section,
        start: 'top top',
        end: () => {
          const certBudget  = (n - 1) * getStepH() + getStepH() * 1.2;
          const outroBudget = getStepH() * OUTRO_BUDGET;
          return `+=${certBudget + outroBudget}`;
        },
        pin: true,
        scrub: 3,
        anticipatePin: 1,
        invalidateOnRefresh: true,

        onUpdate(self) {
          const p       = self.progress;
          const certEnd = getCertEnd();

          // ── Cert strip ────────────────────────────────────────
          const certP = Math.min(1, p / certEnd);
          tlImg.progress(certP);
          tlTxt.progress(certP);
          const idx = Math.min(n - 1, Math.round(certP * (n - 1)));
          setActiveIndex(idx);

          // ── Raw outro progress (0→1 across the full outro budget)
          const rawOutroP = certEnd >= 1
            ? 0
            : Math.max(0, (p - certEnd) / (1 - certEnd));

          // ── Phase 1: Circle reveal (rawOutroP 0 → REVEAL_THRESHOLD) ──
          const revealP = Math.min(1, rawOutroP / REVEAL_THRESHOLD);
          tlOutro.progress(revealP);
          setOutroReveal(revealP);

          // ── Phases 2 & 3 only start after reveal is complete ─────────
          const postRevealP = rawOutroP <= REVEAL_THRESHOLD
            ? 0
            : (rawOutroP - REVEAL_THRESHOLD) / (1 - REVEAL_THRESHOLD);

          // ── Phase 2: maskImage slides in from right (0 → IMAGE_PHASE) ─
          const imageP = Math.min(1, postRevealP / IMAGE_PHASE);
          setOutroImageProg(imageP);

          // ── Phase 3: Cards fly in from left (IMAGE_PHASE → 1.0) ───────
          const cardP = postRevealP <= IMAGE_PHASE
            ? 0
            : (postRevealP - IMAGE_PHASE) / (1 - IMAGE_PHASE);
          setOutroCards(cardP);

          // Pointer events: enable once reveal has started
          const outroEl = document.querySelector('.cv-outro-wrap');
          if (outroEl) {
            outroEl.style.pointerEvents = rawOutroP > 0.05 ? 'auto' : 'none';
          }
        },
      });

    }, section);

    return () => {
      if (ctxRef.current) { ctxRef.current.revert(); ctxRef.current = null; }
    };
  }, [ready, certs, isMobile]);

  if (!certs || !ready) return null;

  return (
    <section
      ref={sectionRef}
      id="certificates"
      style={{
        background: 'var(--black)',
        position: 'relative',
        minHeight: '100vh',
        overflow: 'hidden',
        touchAction: 'pan-y',
      }}
    >
      {/* ── HEADER STRIP ──────────────────────────────────────────── */}
      <div style={{
        position: 'absolute',
        top: 0, left: 0, right: 0,
        height: `${HEADER_H}px`,
        zIndex: 20,
        display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between',
        padding: '0 5vw 1.2rem',
        borderBottom: '1px solid #1a1a1a',
        boxSizing: 'border-box',
        background: 'var(--black)',
        pointerEvents: 'none',
      }}>
        <div>
          <div className="cv-header-label" style={{
            display: 'flex', alignItems: 'center', gap: '0.6rem',
            marginBottom: '1.5rem',
          }}>
            <span style={{
              fontFamily: 'Space Mono, monospace', fontSize: '0.55rem',
              color: 'var(--acid)', letterSpacing: '0.2em',
            }}>05</span>
            <div style={{ width: 10, height: '1px', background: 'var(--acid)', opacity: 0.4 }} />
            <span style={{
              fontFamily: 'Space Mono, monospace', fontSize: '0.55rem',
              color: 'var(--acid)', letterSpacing: '0.18em', textTransform: 'uppercase',
            }}>Credentials</span>
          </div>
          <h2 className="cv-header-h2" style={{
            fontFamily: 'Syne, sans-serif', fontWeight: 800,
            fontSize: isMobile ? 'clamp(1.4rem,5vw,2rem)' : 'clamp(1.6rem,3vw,3rem)',
            letterSpacing: '-0.04em', lineHeight: 0.9,
            margin: 0, color: 'var(--white)',
          }}>
            Earned{' '}<span style={{ color: 'var(--acid)' }}>Badges</span>
          </h2>
        </div>
        <div style={{
          fontFamily: 'Space Mono, monospace',
          textAlign: 'right', pointerEvents: 'auto',
        }}>
          <span style={{
            fontSize: isMobile ? '1.6rem' : '2.4rem',
            fontWeight: 700, color: 'var(--acid)',
            display: 'block', lineHeight: 1,
          }}>
            {pad(activeIndex + 1)}
          </span>
          <span style={{ fontSize: '0.55rem', color: '#444', letterSpacing: '0.12em' }}>
            / {pad(certs.length)} CERTS
          </span>
        </div>
      </div>

      {/* ── PROGRESS RAIL ─────────────────────────────────────────── */}
      <ProgressRail count={certs.length} activeIndex={activeIndex} isMobile={isMobile} />

      {/* ── IMAGE STRIP VIEWPORT ──────────────────────────────────── */}
      <div style={{
        position: 'absolute',
        top:    `${HEADER_H}px`,
        left:   0,
        width:  isMobile ? '100%' : '50%',
        height: isMobile ? `${IMAGE_ZONE_H}px` : undefined,
        bottom: isMobile ? undefined : `${TICKER_H}px`,
        overflow: 'hidden',
        zIndex: 5,
      }}>
        <div
          ref={imgPanelRef}
          style={{
            display: 'flex', flexDirection: 'row',
            width: `${certs.length * 100}%`,
            height: '100%',
            willChange: 'transform',
          }}
        >
          {certs.map((cert, i) => (
            <div
              key={cert.id || i}
              style={{
                width: `${100 / certs.length}%`,
                flexShrink: 0, height: '100%',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                padding: isMobile ? '1rem 8vw' : '2rem 3vw 2rem 5vw',
                boxSizing: 'border-box',
              }}
            >
              <div style={{
                width: '100%',
                maxWidth: isMobile ? '80vw' : 500,
                aspectRatio: '4/3',
                overflow: 'hidden',
              }}>
                <CertImage
                  src={cert.src} alt={cert.title}
                  color={cert.color} title={cert.title} issuer={cert.issuer}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ── DIVIDER — desktop only ─────────────────────────────────── */}
      {!isMobile && (
        <div style={{
          position: 'absolute',
          top: `${HEADER_H}px`, bottom: `${TICKER_H}px`,
          left: '50%', width: '1px',
          background: 'linear-gradient(to bottom, #141414, #222 20%, #222 80%, #141414)',
          zIndex: 8, pointerEvents: 'none',
        }} />
      )}

      {/* ── TEXT STRIP VIEWPORT ───────────────────────────────────── */}
      <div style={{
        position: 'absolute',
        top:    isMobile ? `${HEADER_H + IMAGE_ZONE_H}px` : `${HEADER_H}px`,
        left:   isMobile ? 0 : '50%',
        width:  isMobile ? '100%' : '50%',
        height: isMobile ? MOBILE_TEXT_H : undefined,
        bottom: isMobile ? undefined : `${TICKER_H}px`,
        overflow: 'hidden',
        zIndex: 10,
      }}>
        <div
          ref={txtPanelRef}
          style={{
            display: 'flex', flexDirection: 'row',
            width: `${certs.length * 100}%`,
            height: '100%',
            willChange: 'transform',
          }}
        >
          {certs.map((cert, i) => (
            <div
              key={cert.id || i}
              style={{
                width: `${100 / certs.length}%`,
                flexShrink: 0, height: '100%',
              }}
            >
              <CertContent
                cert={cert}
                index={i}
                total={certs.length}
                isMobile={isMobile}
              />
            </div>
          ))}
        </div>
      </div>

      {/* ── TICKER STRIP ──────────────────────────────────────────── */}
      <div style={{
        position: 'absolute',
        bottom: 0, left: 0, right: 0,
        height: `${TICKER_H}px`,
        overflow: 'hidden',
        borderTop: '1px solid #111',
        display: 'flex', alignItems: 'center',
        background: 'var(--black)', zIndex: 25,
      }}>
        <div style={{
          display: 'flex', gap: '2rem', whiteSpace: 'nowrap',
          animation: 'cv-ticker 30s linear infinite',
        }}>
          {[...certs, ...certs, ...certs, ...certs].map((c, i) => (
            <span key={i} style={{
              fontFamily: 'Syne, sans-serif', fontWeight: 700,
              fontSize: '0.7rem', letterSpacing: '-0.01em',
              color: i % 2 === 0 ? 'var(--white)' : `${c.color}`,
            }}>
              {c.title}
              <span style={{ opacity: 0.15, marginLeft: '0.5rem' }}>·</span>
            </span>
          ))}
        </div>
      </div>

      {/* ── OUTRO REVEAL ──────────────────────────────────────────── */}
      {/*
        Circle wipe expands first (outroReveal drives clip-path via tlOutro).
        Then maskImage slides in from right (outroImageProg).
        Then review cards fly in from left (outroCards).
      */}
      <div
        className="cv-outro-wrap"
        style={{
          position:      'absolute',
          top: 0, left: 0,
          width:         '100%',
          height:        '100%',
          zIndex:        40,
          overflow:      'hidden',
          background:    'var(--black)',
          pointerEvents: 'none',
        }}
      >
        <OutroReviews
          imageProgress={outroImageProg}
          cardProgress={outroCards}
          isMobile={isMobile}
          reviews={reviews}
          maskImage={outroMaskImage}
        />
      </div>

      <style>{`
        @keyframes cv-ticker {
          from { transform: translateX(0); }
          to   { transform: translateX(-50%); }
        }
      `}</style>
    </section>
  );
}

